import ReactDOM from 'react-dom';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { IconButton, Typography, Button, List, ListItem, ListItemText, TextField } from '@mui/material';
import { Link as MUILink } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { ThemeProvider } from '@emotion/react';
import Box from '@mui/material/Box';
import { useMediaQuery } from 'react-responsive';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import * as Scroll from 'react-scroll';
import { Link, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import React, { useState } from "react";
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  // Link
} from "react-router-dom";
import { Helmet } from "react-helmet";




let theme = createTheme({
  action: {
    active: '#aaaaaa'
  }
});
theme = responsiveFontSizes(theme);

const sectionHeaderStyle = { fontFamily: 'Manrope, sans-serif' }
const subHeaderStyle = { fontSize: 18, lineHeight: 1.15, display: 'inline-block', fontFamily: 'Rubik, sans-serif', fontWeight: 'bold' };
const bodyStyle = { fontFamily: 'Rubik, sans-serif' };

function App() {
  return <Router>
    <Switch>
      <Route path='/technology'>
        <Technical />
      </Route>
      <Route path='/solutions'>
        <Solutions />
      </Route>
      <Route path='/healthcare'>
        <HealthCare />
      </Route>
      <Route path='/hiring'>
        <Hiring />
      </Route>
      <Route path='/ml_ds.html'>
        <MLDS />
      </Route>
      <Route path='/cryptocurrency.html'>
        <Cryptocurrency />
      </Route>
      <Route path="/banking_compute.html">
        <BankingCompute />
      </Route>
      <Route path="/devices">
        <Devices />
      </Route>
      <Route path="/legal">
        <Legal />
      </Route>
      <Route path="/meetup">
        <Meetup />
      </Route>
      <Route path="/">
        <Landing />
      </Route>
      {/* <Route path="/users">
      <Users />
    </Route>*/}
    </Switch>
  </Router>

}

function MLDS() {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })



  return <div style={{ marginTop: theme.spacing(5), marginLeft: isTabletOrMobile ? 20 : 200, marginRight: isTabletOrMobile ? 20 : 200, marginTop: 100 }}>
    <div style={{ width: '100%' }}>
      <BackToOnai />
      <Typography variant='h2' style={sectionHeaderStyle}>Get started with next-generation cloud AI and analytics</Typography>
      <Typography style={bodyStyle}>
        Data analytics and artificial intelligence are indispensable to anyone or any business that wants to stay ahead of the game.
        But how can you take advantage of the latest innovations without hiring an army of Ph.D.s and building out a massive data center?
        Install ON AI<span>&#174;</span> software on premise, or use Onai's cloud offerings to gain a next-generation cloud platform for powerful artificial
        intelligence and data analysis. Its powerful, easy-to-use natural language interface get up to speed quickly with an interactive
        analytics notebook and leverage powerful computer vision, speech, and other AI capabilities.
      </Typography>
      <Typography style={bodyStyle}>
        Also ask about ordering dedicated Onai computers and smart speakers to get these capabilities powered locally on site.
      </Typography>
      <Box mt={2} />
      <Typography style={bodyStyle}>
        Order / Request More Information

        <form action='mailto:info@onai.com' method="post" enctype="text/plain" style={{ display: 'flex', flexDirection: 'column' }}>
          <TextField
            placeholder='Name*'
            required
            name="name"
          />
          <Box mb={1} />
          <TextField
            placeholder='E-Mail*'
            required
            name="mail"
          />
          <Box mb={1} />
          <TextField
            placeholder='Organization'
            name="organization"
          />
          <Box mb={1} />
          <TextField
            placeholder='Phone Number'
            name='ph'
          />
          <Box mb={1} />
          <TextField
            placeholder='Subject*'
            name='subject'
            required
          />
          <Box mb={1} />
          <TextField
            placeholder='Query'
            multiline
            rows={4}
          />
          <Box mb={1} />
          <Button
            type="submit"
            variant='contained'
            color='inherit'
            style={{ display: 'flex', alignSelf: 'center' }}
          >
            Submit
          </Button>
        </form>
      </Typography>
    </div>
  </div >
}

function Cryptocurrency() {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })



  return <ThemeProvider theme={theme}>
    <div style={{ marginTop: theme.spacing(5), marginLeft: isTabletOrMobile ? 20 : 200, marginRight: isTabletOrMobile ? 20 : 200, marginTop: 100 }}>
      <div style={{ width: '100%' }}>
        <BackToOnai />
        <Typography variant='h2' style={sectionHeaderStyle}>Cryptocurrency and Blockchain Solutions</Typography>
        <Typography style={bodyStyle}>
          Onai has developed state-of-the-art technology in blockchain, cryptocurrency, and market information technology.
          Please fill out the below form if you're interested in obtaining information about goods or services on Coronai
          or other cryptocurrency ledgers, offering goods or services, participating in a blockchain-enabled global computer
          network and platform, or leveraging our solutions around modern payments (including digital currency exchange) and cryptographic protocols.
        </Typography>
        <Typography style={bodyStyle}>
          Also ask about ordering dedicated Onai computers and smart speakers to get these capabilities powered locally on site.
        </Typography>
        <Box mt={2} />
        <Typography style={bodyStyle}>
          Order / Request More Information

          <form action='mailto:info@onai.com' method="post" enctype="text/plain" style={{ display: 'flex', flexDirection: 'column' }}>
            <TextField
              placeholder='Name*'
              required
              name="name"
            />
            <Box mb={1} />
            <TextField
              placeholder='E-Mail*'
              required
              name="mail"
            />
            <Box mb={1} />
            <TextField
              placeholder='Organization'
              name="organization"
            />
            <Box mb={1} />
            <TextField
              placeholder='Phone Number'
              name='ph'
            />
            <Box mb={1} />
            <TextField
              placeholder='Subject*'
              name='subject'
              required
            />
            <Box mb={1} />
            <TextField
              placeholder='Query'
              multiline
              rows={4}
            />
            <Box mb={1} />
            <Button
              type="submit"
              variant='contained'
              color='inherit'
              style={{ display: 'flex', alignSelf: 'center' }}
            >
              Submit
            </Button>
          </form>
        </Typography>
      </div>
    </div >
  </ThemeProvider>
}

function BankingCompute() {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })



  return <ThemeProvider theme={theme}>
    <div style={{ marginTop: theme.spacing(5), marginLeft: isTabletOrMobile ? 20 : 200, marginRight: isTabletOrMobile ? 20 : 200, marginTop: 100 }}>
      <div style={{ width: '100%' }}>
        <BackToOnai />
        <Typography variant='h2' style={sectionHeaderStyle}>Onai Cryptocurrency Banking for Decentralized Compute</Typography>
        <Typography style={bodyStyle}>
          Leveraging its cutting edge technology in the cryptographic space, Onai’s cryptocurrency
          token Coronai has been purchased by early endorsers. While not broadly available,
          we welcome inquiries about how it can help you. Tailored for providers of decentralized
          computational services, learn how our solutions allow you to leverage idle capacity,
          avoid traditional bank transaction fees and pain points with superior transaction routing service,
          and conduct secure exchanges in the cryptocurrencies or fiat currencies that make sense for you!
        </Typography>
        <Typography style={bodyStyle}>
          Onai has won and performed projects with DARPA, NASA, and the NSF, and is committed to the
          application of cutting edge technology to improving computing, the financial system, and more.
        </Typography>
        <Box mt={2} />
        <Typography style={bodyStyle}>
          Order / Request More Information

          <form action='mailto:info@onai.com' method="post" enctype="text/plain" style={{ display: 'flex', flexDirection: 'column' }}>
            <TextField
              placeholder='Name*'
              required
              name="name"
            />
            <Box mb={1} />
            <TextField
              placeholder='E-Mail*'
              required
              name="mail"
            />
            <Box mb={1} />
            <TextField
              placeholder='Organization'
              name="organization"
            />
            <Box mb={1} />
            <TextField
              placeholder='Phone Number'
              name='ph'
            />
            <Box mb={1} />
            <TextField
              placeholder='Subject*'
              name='subject'
              required
            />
            <Box mb={1} />
            <TextField
              placeholder='Query'
              multiline
              rows={4}
            />
            <Box mb={1} />
            <Button
              type="submit"
              variant='contained'
              color='inherit'
              style={{ display: 'flex', alignSelf: 'center' }}
            >
              Submit
            </Button>
          </form>
        </Typography>
      </div>
    </div >
  </ThemeProvider>
}

function Devices() {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })



  return <ThemeProvider theme={theme}>
    <div style={{ marginTop: theme.spacing(5), marginLeft: isTabletOrMobile ? 20 : 200, marginRight: isTabletOrMobile ? 20 : 200, marginTop: 100 }}>
      <div style={{ width: '100%' }}>
        <BackToOnai />
        <Typography variant='h2' style={sectionHeaderStyle}>Onai<span>&trade;</span> Hardware Solutions</Typography>
        <Box mt={2} />
        <Typography style={bodyStyle}>
          Onai’s unique hardware offerings, including smart speakers/cameras and secure computers,
          are well-suited to show off the capabilities of our privacy-preserving AI capabilities,
          power world-class research, and perform sophisticated machine learning and data analysis.
          Please complete the form below to inquire about our hardware offerings.
        </Typography>
        <Box mt={2} />
        <div style={{ alignItems: 'center', display: 'flex' }}>
          {/* <img src='/hardware-echo.jpg' width='50%' />
          <img src='/hardware-mini-pc.jpg' width='50%' /> */}
          <img src='/hardware-mini-pc.jpg' width='50%' />
          <img src='/mini_pc_box_nt.png' width='50%' />
        </div>
        <Box mt={2} />
        <Typography style={bodyStyle}>
          Order / Request More Information

          <form action='mailto:info@onai.com' method="post" enctype="text/plain" style={{ display: 'flex', flexDirection: 'column' }}>
            <TextField
              placeholder='Name*'
              required
              name="name"
            />
            <Box mb={1} />
            <TextField
              placeholder='E-Mail*'
              required
              name="mail"
            />
            <Box mb={1} />
            <TextField
              placeholder='Organization'
              name="organization"
            />
            <Box mb={1} />
            <TextField
              placeholder='Phone Number'
              name='ph'
            />
            <Box mb={1} />
            <TextField
              placeholder='Subject*'
              name='subject'
              required
            />
            <Box mb={1} />
            <TextField
              placeholder='Query'
              multiline
              rows={4}
            />
            <Box mb={1} />
            <Button
              type="submit"
              variant='contained'
              color='inherit'
              style={{ display: 'flex', alignSelf: 'center' }}
            >
              Submit
            </Button>
          </form>
        </Typography>
      </div>
    </div >
  </ThemeProvider>
}

function Landing() {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })

  const sectionStyle = { marginLeft: isTabletOrMobile ? 20 : 200, marginRight: isTabletOrMobile ? 20 : 200, marginTop: 100 }

  return <ThemeProvider theme={theme}>
    <div className='container'>
      <section style={{ alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <img src="/onai_text_black.png" style={{ width: isTabletOrMobile ? 200 : 300 }} />
        <Box style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column', textAlign: 'center', marginLeft: 30, marginRight: 30, maxWidth: 500, marginTop: 20 }}>
          <Typography variant='button' style={{ fontSize: 24, lineHeight: 1.15 }}>Imagine Better Together</Typography><br />
          <Typography>
            Through potent new artificial intelligence and cryptographic technologies,
            we are unlocking the power of next-generation collaboration and computation for us all.
          </Typography>
        </Box>
        <Link to="firstSection" smooth={true}>
          <IconButton size='large' style={{ marginTop: 20 }}><KeyboardArrowDownIcon /></IconButton>
        </Link>
      </section>
      <Element name="firstSection">
        <div style={{ marginLeft: isTabletOrMobile ? theme.spacing(1) : theme.spacing(50), marginRight: isTabletOrMobile ? theme.spacing(1) : theme.spacing(50), justifyContent: 'flex-start', alignItems: 'flex-start', display: 'flex', flexDirection: 'column' }}>
          <Typography variant='h4' style={{ marginBottom: theme.spacing(2) }}>LEARN MORE</Typography>
          <Grid container spacing={1}>
            <Grid item xs={isTabletOrMobile ? 12 : 6}>
              <Paper elevation={0} style={{ display: 'flex', alignItems: 'center', padding: theme.spacing(2) }}>
                {/* <Avatar src='/person.jpeg' sx={{ width: 100, height: 100 }} /> */}
                <div style={{ marginLeft: theme.spacing(2) }}>
                  <Typography variant="button" style={subHeaderStyle}>Healthcare</Typography>
                  <Typography style={bodyStyle}>
                    Our technology is enabling a new paradigm of collaboration across healthcare, facilitating secure data analytics and AI across leading institutions.
                    <span>&nbsp;</span><IconButton href='/healthcare' size={'small'}><ArrowForwardRoundedIcon fontSize='inherit' /></IconButton>
                  </Typography>
                </div>
              </Paper>
            </Grid>
            <Grid item xs={isTabletOrMobile ? 12 : 6}>
              <Paper elevation={0} style={{ display: 'flex', alignItems: 'center', padding: theme.spacing(2) }}>
                {/* <Avatar src='/person.jpeg' sx={{ width: 100, height: 100 }} /> */}
                <div style={{ marginLeft: theme.spacing(2) }}>
                  <Typography variant="button" style={subHeaderStyle}>Technology</Typography>
                  <Typography style={bodyStyle}>
                    Onai has well-demonstrated expertise in AI, blockchain, cryptography/cryptocurrency, and more. Our foundational advances are enabling meaningful real-world impacts.
                    <span>&nbsp;</span><IconButton href='/technology' size={'small'}><ArrowForwardRoundedIcon fontSize='inherit' /></IconButton>
                  </Typography>
                </div>
              </Paper>
            </Grid>
            <Grid item xs={isTabletOrMobile ? 12 : 6}>
              <Paper elevation={0} style={{ display: 'flex', alignItems: 'center', padding: theme.spacing(2) }}>
                {/* <Avatar src='/person.jpeg' sx={{ width: 100, height: 100 }} /> */}
                <div style={{ marginLeft: theme.spacing(2) }}>
                  <Typography variant="button" style={subHeaderStyle}>Team</Typography>
                  <Typography style={bodyStyle}>
                    Enjoy tackling interesting challenges? Whether for a full time position, postdoctoral fellowship, internship, or consultancy, we’d like to hear from you.
                    <IconButton href='/hiring' size={'small'}><ArrowForwardRoundedIcon fontSize='inherit' /></IconButton>
                  </Typography>
                </div>
              </Paper>
            </Grid>
            <Grid item xs={isTabletOrMobile ? 12 : 6}>
              <Paper elevation={0} style={{ display: 'flex', alignItems: 'center', padding: theme.spacing(2) }}>
                {/* <Avatar src='/person.jpeg' sx={{ width: 100, height: 100 }} /> */}
                <div style={{ marginLeft: theme.spacing(2) }}>
                  <Typography variant="button" style={subHeaderStyle}>Solutions</Typography>
                  <Typography style={bodyStyle}>
                    We’ve performed projects with DARPA, NASA, NSF, and more. Get in touch about On AI<span>&reg;</span> and products and services across analytics, AI, finance, and hardware.
                    <IconButton href='/solutions' size={'small'}><ArrowForwardRoundedIcon fontSize='inherit' /></IconButton>
                  </Typography>
                </div>
              </Paper>
            </Grid>
          </Grid>
        </div>
      </Element>

      {/* <Element name="firstSection">
        <section style={sectionStyle}>
          <Technical isTabletOrMobile={isTabletOrMobile} />
        </section>
      </Element>
      <section style={sectionStyle}>
        <HealthCare isTabletOrMobile={isTabletOrMobile} />
      </section>
      <section style={sectionStyle}>
        {isTabletOrMobile ? <AdvisersMobile /> : <Advisers />}
      </section>
      <section style={sectionStyle}>
        {isTabletOrMobile ? <CareersMobile /> : <Careers />}
      </section> */}
    </div >
  </ThemeProvider>
}

function BackToOnai() {
  return <Button variant="text" href='/' color='inherit' style={{ color: '#808080' }} startIcon={<ArrowBackRoundedIcon />}>
    <img src={"/onai_text_black_left.png"} height={15} />
  </Button>
}

function StyledLink(props) {

  const { href, title, rel } = props;

  return <MUILink color='#808080' href={href} rel={rel}>{title}</MUILink>

}

function Technical() {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })

  const [showBib, setShowBib] = useState(false);

  return <div style={{ marginTop: theme.spacing(5), marginLeft: isTabletOrMobile ? 20 : 200, marginRight: isTabletOrMobile ? 20 : 200, marginTop: 100 }}>
    <div style={{ width: '100%' }}>
      <BackToOnai />
      <Typography variant='h2' style={sectionHeaderStyle}>TECHNOLOGY</Typography>
      <Box mb={2} />
      <Typography style={bodyStyle}>
        Our products coalesce advances across an ambitious number of computational disciplines.
        Want to know more than is on this page? Check out links to some of our publications
        interspersed below or, better yet, <StyledLink href='/hiring' title='get in touch' />.
      </Typography>
      <Box mb={2} />
      <Typography style={bodyStyle}>
        Want to go even deeper? Get some of the basics through courses our team has taught on <StyledLink href='http://deeplearningcourse.onai.com/' title='AI' /> and <StyledLink href='http://blockchaincourse.onai.com/' title='blockchain' />.
        And peruse the research of some of our luminary advisers, who include <StyledLink href='https://people.eecs.berkeley.edu/~pabbeel/' title='Prof. Pieter Abbeel' />,
        one the world's leading figures in deep learning; <StyledLink href='https://www.ece.ucdavis.edu/~jowens/' title=' Prof. John Owens' />, a leading figure in GPU computing; <StyledLink href='http://timroughgarden.org' title='Prof. Tim Roughgarden' />, an expert in algorithms and blockchain game theory; <StyledLink href='https://profiles.stanford.edu/nirav-shah' title='Dr. Nirav Shah' />,
        former Commissioner of the NY State Department of Health; and several others.
      </ Typography >
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Paper elevation={0} style={{
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 30,
          }}>
            <Typography variant="button" style={subHeaderStyle} component="span">AI.</Typography> <Typography component='span' style={bodyStyle}>
              We have developed a variety of technologies for decentralized deep learning (with a particular focus on GNNs) and natural language processing (NLP).
              Within NLP, we have a particular interest in <MUILink href='#'
                color='#808080'
                onClick={e => {
                  e.preventDefault();
                  setShowBib(!showBib);
                }}>analysis of web content</MUILink>&mdash;of all languages.
              We also have developed and brought to bear novel privacy-preserving deep learning methods that allow the benefits of artificial
              intelligence to be obtained without any exposure of sensitive data.
            </Typography>
            <Typography style={bodyStyle}>
              {/* Consistently formatted bibliography of all the NLP publications from 2019 to present, plus Volkmar’s book chapter.
              Include an image of the cover of Shriphani’s book at the bottom of the div. */}
              {showBib && <div style={{ marginTop: 20 }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <img src='/book.jpeg' width='50px' style={{ marginRight: 20 }} />
                  <div>
                    <cite>
                      <StyledLink href='https://www.springer.com/gp/book/9789811656248' title='Low Resource Social Media Text Mining' />
                    </cite><br />
                    S Palakodety, AR KhudaBukhsh, G Jayachandran<br />
                    SpringerBriefs in Computer Science
                  </div>
                </div>
                <Box mb={theme.spacing(2)} />
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <img src='/book_handwritten.jpg' width='50px' style={{ marginRight: 20 }} />
                  <div>
                    <cite>
                      <StyledLink href='https://www.springer.com/gp/book/9789811656248' title='Handwritten Keyword Spotting in Historical Documents' />
                    </cite><br />
                    V Frinken, S Palakodety<br />
                    Chapter in Handwritten Historical Document Analysis, Recognition, And Retrieval-State Of The Art And Future Trends<br />
                  </div>
                </div>
                <Box mb={theme.spacing(2)} />
                <div>
                  <cite>
                    <StyledLink href='https://arxiv.org/pdf/2008.13347.pdf' title='Discovering bilingual lexicons in polyglot word embeddings' />
                  </cite><br />
                  AR KhudaBukhsh, S Palakodety, TM Mitchell<br />
                  In submission
                </div>
                <Box mb={theme.spacing(2)} />
                <div>
                  <cite>
                    <StyledLink href='https://arxiv.org/abs/2106.12044' title='Empathy and Hope: Resource Transfer to Model Inter-country Social Media Dynamics' />
                  </cite><br />
                  CH Yoo, S Palakodety, R Sarkar, AR KhudaBukhsh<br />
                  Proceedings of the 1st Workshop on NLP for Positive Impact (NLP4PosImpact 2021)
                </div>
                <Box mb={theme.spacing(2)} />
                <div>
                  <cite>
                    <StyledLink href='https://arxiv.org/pdf/1910.03206.pdf' title='Harnessing code switching to transcend the linguistic barrier' />
                  </cite><br />
                  AR KhudaBukhsh, S Palakodety, JG Carbonell<br />
                  Proceedings of the Twenty-Ninth International Joint Conference on Artificial Intelligence (IJCAI-20)
                </div>
                <Box mb={theme.spacing(2)} />
                <div>
                  <cite>
                    <StyledLink href='https://arxiv.org/pdf/1910.03206.pdf' title='Voice for the voiceless: Active sampling for finding comments supporting the rohingyas' />
                  </cite><br />
                  S Palakodety, AR KhudaBukhsh, JG Carbonell<br />
                  Proceedings of the Thirty-Fourth AAAI Conference on Artificial Intelligence (AAAI-20)
                </div>
                <Box mb={theme.spacing(2)} />
                <div>
                  <cite>
                    <StyledLink href='https://aclanthology.org/2020.wnut-1.24.pdf' title='Annotation Efficient Language Identification from Weak Labels' />
                  </cite><br />
                  S Palakodety, A KhudaBukhsh<br />
                  Proceedings of the Sixth Workshop on Noisy User-generated Text (W-NUT 2020)
                </div>
                <Box mb={theme.spacing(2)} />
                <div>
                  <cite>
                    <StyledLink href='https://crcs.seas.harvard.edu/files/crcs/files/ai4sg_2020_paper_79.pdf' title='On NLP methods robust to noisy Indian social media data' />
                  </cite><br />
                  AR KhudaBukhsh, S Palakodety, JG Carbonell<br />
                  AI for Social Good Workshop 2020
                </div>
                <Box mb={theme.spacing(2)} />
                <div>
                  <cite>
                    <StyledLink href='https://arxiv.org/pdf/1910.03206.pdf' title='Mining insights from large-scale corpora using fine-tuned language models' />
                  </cite><br />
                  S Palakodety, AR KhudaBukhsh, JG Carbonell<br />
                  24th European Conference on Artificial Intelligence (ECAI 2020)
                </div>
                <Box mb={theme.spacing(2)} />
                <div>
                  <cite>
                    <StyledLink href='https://arxiv.org/pdf/1909.12940.pdf' title='Hope speech detection: A computational analysis of the voice of peace' />
                  </cite><br />
                  S Palakodety, AR KhudaBukhsh, JG Carbonell<br />
                  24th European Conference on Artificial Intelligence (ECAI 2020)
                </div>
                <Box mb={theme.spacing(2)} />
                <div>
                  <cite>
                    <StyledLink href='https://thakur.cs.ucdavis.edu/assets/pubs/SMT2019.pdf' title='An SMT Approach To A Multiparty Economic Scheduling Problem' />
                  </cite><br />
                  S Palakodety, G Jayachandran, AV Thakur<br />
                  17th International Workshop on Satisfiability Module Theories (SMT'19)
                </div>
              </div>}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={0} style={{
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 30,
            verticalAlign: 'top',
            lineHeight: 1
          }}>
            <Typography variant="button" style={subHeaderStyle} component="span">Blockchain.</Typography> <Typography component="span" style={bodyStyle}>
              We have developed a powerful new blockchain protocol, created several inventions in the space,
              and are working on a slew of exciting initiatives that leverage the potential of blockchain
              technology to change how we collaborate.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={0} style={{
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 30
          }}>
            <Typography variant="button" style={subHeaderStyle} component="span">Cryptography.</Typography> <Typography component="span" style={bodyStyle}>
              Advances in cryptography enable greater data innovation by reducing the risks of data exposure and facilitating greater interoperability and collaboration. Secure multiparty computation (MPC) enables parties, each of which is holding sensitive data, to collaborate to compute a joint result, without requiring any party to expose its data to the others. Homomorphic encryption enables the performance of computations on encrypted data, without knowing the decryption key. We also heavily leverage zero-knowledge proofs, which allow various properties to be established to others without exposure of underlying data.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={0} style={{
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 30
          }}>
            <Typography variant="button" style={subHeaderStyle} component="span">Distributed computation.</Typography> <Typography component="span" style={bodyStyle}>
              Decentralized computing enables efficient scaling of workloads and enables disparate parties to collaborate with minimal or no setup required. We’re at the very beginning of a revolution.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={0} style={{
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 30
          }}>
            <Typography variant="button" style={subHeaderStyle} component="span">Economics.</Typography> <Typography component="span" style={bodyStyle}>
              Technical insight on its own is insufficient; it must be coupled with sound incentives that align with people’s needs.
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper elevation={0} style={{
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 30
          }}>
            <Typography variant="button" style={subHeaderStyle} component="span">Formal Methods.</Typography> <Typography component="span" style={bodyStyle}>
              We have an emphasis on code correctness. As we’ve seen over and over with cryptocurrency protocols,
              databases, and more, bugs all too often result in exposure of data or loss of funds. Formal methods
              involve proving the correctness and security of code. Our preferred tool of choice is <i>dependent typing</i>.
              We’re also pioneers on formal methods for zero knowledge proofs, the topic of a <StyledLink href='https://fmcpworkshop.onai.com' title='workshop' /> we organized at NASA in 2020.
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper elevation={0} style={{
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 30
          }}>
            <Typography variant="button" style={subHeaderStyle} component="span">Graph analytics.</Typography> <Typography component="span" style={bodyStyle}>
              Graphs represent how entities connect to one another and have a range of applications,
              including supply chains, fraud detection, and more. We have deep experience in large-scale
              accelerated graph algorithms for distributed computation.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <span style={{ padding: 30 }}>&hellip;</span>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={0} style={{
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 30
          }}>
            <Typography variant="button" style={subHeaderStyle} component="span">Zombies.</Typography> <Typography component="span" style={bodyStyle}>
              We are ready.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </div >
  </div >
}

function HealthCare() {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })

  const [showRecoverLinks, setShowRecoverLinks] = useState(false);

  return <div style={{ marginTop: theme.spacing(5), marginLeft: isTabletOrMobile ? 20 : 200, marginRight: isTabletOrMobile ? 20 : 200, marginTop: 100 }}>
    <div style={{ width: '100%' }}>
      <BackToOnai />
      <Typography variant='h2' style={sectionHeaderStyle}>HEALTHCARE</Typography>
      <Typography style={bodyStyle}>
        The answers to many important questions are embedded in healthcare data around the globe.
        Onai technology is helping unlock the answers.
        While we're still quiet, we've won projects from the NSF, NIH, and others, collaborate with leading clinicians and researchers, and are just getting started!
      </Typography>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Paper elevation={0} style={{
            // height: 200,
            padding: 30
          }}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <div>
                <Typography variant="button" style={subHeaderStyle}>RECovER</Typography>
                <Typography style={bodyStyle}>
                  Onai initiated the <StyledLink href="https://www.recover21.org/" title='RECovER initiative' />, an experimental application of our cryptographic technologies to enable COVID-19 records across institutions to be queried by researchers without any information leaked about each institution’s data. <MUILink href='#'
                    color='#808080'
                    onClick={e => {
                      e.preventDefault();
                      setShowRecoverLinks(true);
                    }}>Read more.</MUILink>
                  {showRecoverLinks && <List dense={true} style={{ paddingLeft: 30 }} disablePadding>
                    <ListItem>
                      {/* <ListItemIcon><ArrowForwardRoundedIcon /></ListItemIcon> */}
                      <ListItemText>
                        <StyledLink href='https://www.recover21.org/' title='RECovER' />
                      </ListItemText>
                    </ListItem>
                    <ListItem>
                      {/* <ListItemIcon><ArrowForwardRoundedIcon /></ListItemIcon> */}
                      <ListItemText>
                        <StyledLink href='https://scienceblog.cincinnatichildrens.org/real-time-secure-and-confidential-data-sharing-in-the-fight-against-covid-19-and-beyond/' title='Real-Time, Secure, and Confidential Data Sharing in the Fight Against COVID-19 and Beyond' />
                      </ListItemText>
                    </ListItem>
                    <ListItem>
                      {/* <ListItemIcon><ArrowForwardRoundedIcon /></ListItemIcon> */}
                      <ListItemText>
                        <StyledLink href='https://www.drugdiscoverynews.com/-p-lang-en-us-blending-datasets-for-better-research-p-15033' title='Blending datasets for better research' />
                      </ListItemText>
                    </ListItem>
                    <ListItem>
                      {/* <ListItemIcon><ArrowForwardRoundedIcon /></ListItemIcon> */}
                      <ListItemText>
                        <StyledLink href='https://www.purdue.edu/newsroom/releases/2020/Q4/artificial-intelligence-collaboration-seeking-to-hasten-covid-19-insights.html' title='Artificial intelligence collaboration seeking to hasten COVID-19 insights' />
                      </ListItemText>
                    </ListItem>
                  </List>}
                </Typography>
              </div>
              {!isTabletOrMobile && <><Box mr={10} /><img src='/mui_recover.png' width='20%' /></>}
            </div>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={0} style={{
            // height: 200,
            padding: 30
          }}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              {!isTabletOrMobile && <><img src='/mui_secure_mpc.png' width='20%' /><Box mr={10} /></>}
              <div>
                <Typography variant="button" style={subHeaderStyle} >Cross-institutional model training</Typography>
                <Typography style={bodyStyle}>
                  We have developed technology that allows researchers to train AI models across institutions with maximal security and minimal researcher effort. No data leaves each institution’s firewall. We are, for example, applying this with pediatrician-researchers for rare conditions.
                  {/* <img of the hospitals MPC diagram. It’s like the below one but only has the pie chart at the top. Ask Jin for it.> */}
                </Typography>
              </div>
            </div>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={0} style={{
            // height: 200,
            padding: 30
          }}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <div>
                <Typography variant="button" style={subHeaderStyle}>Secure inference</Typography>
                <Typography style={bodyStyle}>
                  If a holder of sensitive data wishes to query a model held by an outside partner, our technology enables that query to be performed in an encrypted manner such that neither the input nor output is exposed to the partner.
                  {/* <img of secure inference loop, ask Jin for below> */}
                </Typography>
              </div>
              {!isTabletOrMobile && <><Box mr={10} /><img src='/mui_secure_inference.png' width='20%' /></>}

            </div>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={0} style={{
            // height: 200,
            padding: 30
          }}>
            <Typography variant="button" style={subHeaderStyle}>Vision</Typography>
            <Typography style={bodyStyle}>
              We are working towards a future of decentralized data-driven healthcare where <i>everyone</i> receives the benefit of the best possible information. Our technology enables a range of sophisticated machine intelligence to be developed and applied in an open manner, while simultaneously improving data security.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </div >
  </div >
}

function Hiring() {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })

  return <div style={{ marginTop: theme.spacing(5), marginLeft: isTabletOrMobile ? 20 : 200, marginRight: isTabletOrMobile ? 20 : 200, marginTop: 100 }}>
    <div style={{ width: '100%' }}>
      <BackToOnai />
      <Typography variant='h2' style={sectionHeaderStyle}>HIRING</Typography>
      <Typography style={bodyStyle}>
        <p>Interested in AI, blockchain, cryptography, large-scale computation, verified programming, the sciences, or economics?</p>

        <p>Our team is comprised of great individuals, each of whom contributes unique strengths. The abilities of our world-class team match the scale of our goals.</p>

        <p>Headquartered in Silicon Valley, Onai also has offices elsewhere and our team is drawn from around the globe. We would enjoy speaking with you wherever you’re currently located as we work with people under a variety of arrangements.</p>


        <p>
          {/* <iframe src="https://docs.google.com/document/d/e/2PACX-1vQqeQ8RUjILSL88IR3yqRQg-AvN6Sug2d6w-bZpfk6nTzUqNO2nV5cdiRExPvTG6_PIeBuEtCTKQUWB/pub?embedded=true" style='width:95%;height:700px;border:none'></iframe> */}
          <a href="/openings.html" rel='nofollow'>Specific Listings</a>
        </p>
      </Typography>
    </div>
  </div >
}


function Solutions() {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })

  return <div style={{ marginTop: theme.spacing(5), marginLeft: isTabletOrMobile ? 20 : 200, marginRight: isTabletOrMobile ? 20 : 200, marginTop: 100 }}>
    <div style={{ width: '100%' }}>
      <BackToOnai />
      <Typography variant='h2' style={sectionHeaderStyle}>SOLUTIONS</Typography>
      <Box mb={2} />
      <Typography style={bodyStyle}>
        <StyledLink href="/technology" title='Technical merit' /> is great, positive impact is better.
        The best is yet to come, but get a taste below. Contact us at info@onai.com for more information or <StyledLink href='/meetup' title='meet us' />.
      </Typography>
      <Box mb={2} />
      <Grid container spacing={1}>
        {/* <Grid item xs={12}>
          <Paper elevation={0} style={{
            // height: 200,
            padding: 30
          }}>
            <Typography variant="button" style={subHeaderStyle}>Contact</Typography>
            <Typography style={bodyStyle}>
              <a href="mailto:info@onai.com">info@onai.com</a>
            </Typography>
          </Paper>
        </Grid> */}
        <Grid item xs={12}>
          <Paper elevation={0} style={{
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 30
          }}>
            <Typography variant="button" style={subHeaderStyle}>Healthcare</Typography>
            <Typography style={bodyStyle}>
              Our technology is being applied to healthcare to advance research and improve care for us all. <StyledLink href="/healthcare" title='Learn more' />
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={0} style={{
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 30
          }}>
            <Typography variant="button" style={subHeaderStyle}>Government</Typography>
            <Typography style={bodyStyle}>
              We are honored to have previously won and performed projects with government agencies including DARPA, NASA, and the National Science Foundation. Get in touch to learn more about our open frameworks for parallel/distributed computing and secure, sophisticated AI.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={0} style={{
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 30
          }}>
            <Typography variant="button" style={subHeaderStyle}>Coronai<span>&trade;</span></Typography>
            <Typography style={bodyStyle}>
              While we are not saying much publicly yet, public decentralized computing <i>can</i> solve real world challenges.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={0} style={{
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 30
          }}>
            <Typography variant="button" style={subHeaderStyle}>Hardware</Typography>
            <Typography style={bodyStyle}>
              We are proud to be able to offer integrated <StyledLink href="/devices" title='devices' rel='nofollow' /> that showcase the practical power of our AI, blockchain, and cryptographic technologies.
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper elevation={0} style={{
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 30
          }}>
            <Typography variant="button" style={subHeaderStyle}>More</Typography>
            <Typography style={bodyStyle}>
              Interested in our <StyledLink rel='nofollow' href='/ml_ds.html' title='machine learning and data analytics hosted or on-premise offerings' /> or <StyledLink rel='nofollow' href='/cryptocurrency.html' title='cryptocurrency and marketplaces solutions' /> for <StyledLink rel='nofollow' href='/banking_compute.html' title='cryptocurrency exchange and compute' />?
              Follow the links!
            </Typography>
          </Paper>
        </Grid>

      </Grid>
    </div>
  </div >
}

function Advisers() {
  return <div style={{ width: '100%' }}>
    <Typography variant='h1' style={sectionHeaderStyle}>ADVISERS</Typography>
    <Grid container spacing={1} style={{ width: '100%', paddingLeft: 30, paddingRight: 30 }}>
      <Grid item xs={6}>
        <Paper elevation={1} style={{ display: 'flex', alignItems: 'center', padding: theme.spacing(2) }}>
          <Avatar src='/person.jpeg' sx={{ width: 100, height: 100 }} />
          <div style={{ marginLeft: theme.spacing(2) }}>
            <Typography variant="button" style={subHeaderStyle}>Tuhin Sahai</Typography>
            <Typography style={bodyStyle}>
              aerospace, quantum

            </Typography>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={6}>
        <Paper elevation={1} style={{ display: 'flex', alignItems: 'center', padding: theme.spacing(2) }}>
          <Avatar src='/person.jpeg' sx={{ width: 100, height: 100 }} />
          <div style={{ marginLeft: theme.spacing(2) }}>
            <Typography variant="button" style={subHeaderStyle}>Prince Al Waleed bin Talal Al Saud</Typography>
            <Typography style={bodyStyle}>
              king of the castle
            </Typography>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={6}>
        <Paper elevation={1} style={{ display: 'flex', alignItems: 'center', padding: theme.spacing(2) }}>
          <Avatar src='/person.jpeg' sx={{ width: 100, height: 100 }} />
          <div style={{ marginLeft: theme.spacing(2) }}>
            <Typography variant="button" style={subHeaderStyle}>Coco Chanel</Typography>
            <Typography style={bodyStyle}>
              handbags
            </Typography>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={6}>
        <Paper elevation={1} style={{ display: 'flex', alignItems: 'center', padding: theme.spacing(2) }}>
          <Avatar src='/person.jpeg' sx={{ width: 100, height: 100 }} />
          <div style={{ marginLeft: theme.spacing(2) }}>
            <Typography variant="button" style={subHeaderStyle}>Coco Chanel</Typography>
            <Typography style={bodyStyle}>
              handbags
            </Typography>
          </div>
        </Paper>
      </Grid>
    </Grid>
  </div>
}

function AdvisersMobile() {
  return <div style={{ width: '100%' }}>
    <Typography variant='h1' style={sectionHeaderStyle}>ADVISERS</Typography>
    <Grid container spacing={1} style={{ width: '100%', paddingLeft: 30, paddingRight: 30 }}>
      <Grid item xs={12}>
        <Paper elevation={3} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: theme.spacing(2) }}>
          <Avatar src='/person.jpeg' sx={{ width: 100, height: 100 }} />
          <div style={{ textAlign: 'center', marginTop: theme.spacing(2) }}>
            <Typography variant="button" style={subHeaderStyle}>Tuhin Sahai</Typography>
            <Typography style={bodyStyle}>
              aerospace, quantum
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.


            </Typography>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper elevation={3} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: theme.spacing(2) }}>
          <Avatar src='/person.jpeg' sx={{ width: 100, height: 100 }} />
          <div style={{ textAlign: 'center', marginTop: theme.spacing(2) }}>
            <Typography variant="button" style={subHeaderStyle}>Prince Al Waleed bin Talal Al Saud</Typography>
            <Typography style={bodyStyle}>
              king of the castle
            </Typography>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper elevation={3} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: theme.spacing(2) }}>
          <Avatar src='/person.jpeg' sx={{ width: 100, height: 100 }} />
          <div style={{ textAlign: 'center', marginTop: theme.spacing(2) }}>
            <Typography variant="button" style={subHeaderStyle}>Coco Chanel</Typography>
            <Typography style={bodyStyle}>
              handbags
            </Typography>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper elevation={3} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: theme.spacing(2) }}>
          <Avatar src='/person.jpeg' sx={{ width: 100, height: 100 }} />
          <div style={{ textAlign: 'center', marginTop: theme.spacing(2) }}>
            <Typography variant="button" style={subHeaderStyle}>Coco Chanel</Typography>
            <Typography style={bodyStyle}>
              handbags
            </Typography>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={8} />

    </Grid>
  </div>
}

function Careers() {
  return <div>
    <Typography variant='h1' style={sectionHeaderStyle}>CAREERS</Typography>
    <Grid container spacing={1} style={{ width: '100%', paddingLeft: 30, paddingRight: 30 }}>
      <Grid item xs={6}>
        <Paper elevation={3} style={{
          height: 200,
          padding: theme.spacing(2)
        }}>
          <Typography variant="button" style={subHeaderStyle}>Lemonade Stand Manager</Typography>
          <Typography style={bodyStyle}>
            Citric Engineering
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={6}>
        <Paper elevation={3} style={{
          height: 200,
          padding: theme.spacing(2)
        }}>
          <Typography variant="button" style={subHeaderStyle}>Tractor Designer</Typography>
          <Typography style={bodyStyle}>
            Farmland
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={6}>
        <Paper elevation={3} style={{
          height: 200,
          padding: theme.spacing(2)
        }}>
          <Typography variant="button" style={subHeaderStyle}>Mechanical Engineering</Typography>
          <Typography style={bodyStyle}>
            Cars
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  </div>
}

function Meetup() {

  const [city, setCity] = useState();

  const cityNames = {
    'houston': 'Houston',
    'london': 'London',
    'manila': 'Manila',
    'miami': 'Miami',
    'paris': 'Paris',
    'pittsburgh': 'Pittsburgh',
    'san-francisco': 'San Francisco',
    "shanghai": "Shanghai",
    "taipei": "Taipei",
    "mumbai": "Mumbai",
    "los angeles": "Los Angeles",
    "jakarta": "Jakarta",
    "karachi": "Karachi",
    "lagos": "Lagos",
    "são paulo": "São Paulo",
    "dhaka": "Dhaka",
    "moscow": "Moscow",
    "mexico city": "Mexico City",
    "tokyo": "Tokyo",
    "quezon city": "Quezon City",
    "addis ababa": "Addis Ababa",
    "cairo": "Cairo",
    "kinshasa": "Kinshasa",
    "ho chi minh city": "Ho Chi Minh City",
    "tehran": "Tehran",
    "istanbul": "Istanbul",
    "berlin": "Berlin",
    "paris": "Paris",
    "london": "London",
    "bangkok": "Bangkok",
    "dar es salaam": "Dar es Salaam",
    "johannesburg": "Johannesburg",
    "rome": "Rome",
    "yangon": "Yangon",
    "seoul": "Seoul",
    "bogotá": "Bogotá",
    "nairobi": "Nairobi",
    "madrid": "Madrid",
    "buenos aires": "Buenos Aires",
    "algiers": "Algiers",
    "khartoum": "Khartoum",
    "kampala": "Kampala",
    "baghdad": "Baghdad",
    "kyiv": "Kyiv",
    "toronto": "Toronto",
    "warsaw": "Warsaw",
    "marrakesh": "Marrakesh",
    "samarkand": "Samarkand",
    "riyadh": "Riyadh",
    "sana'a": "Sana'a",
    "lima": "Lima",
    "luanda": "Luanda",
    "kabul": "Kabul",
    "kuala lumpur": "Kuala Lumpur",
    "maputo": "Maputo",
    "kumasi": "Kumasi",
    "abidjan": "Abidjan",
    "kathmandu": "Kathmandu",
    "saint john's": "Saint John's",
    "yerevan": "Yerevan",
    "melbourne": "Melbourne",
    "minsk": "Minsk",
    "thimphu": "Thimphu",
    "sarajevo": "Sarajevo",
    "phenom penh": "Phenom Penh",
    "havana": "Havana",
    "willemstad": "Willemstad",
    "tbilisi": "Tbilisi",
    "reykjavík": "Reykjavík",
    "dublin": "Dublin",
    "tel aviv": "Tel Aviv",
    "almaty": "Almaty",
    "vientiane": "Vientiane",
    "vaduz": "Vaduz",
    "antananarivo": "Antananarivo",
    "lilongwe": "Lilongwe",
    "chișinău": "Chișinău",
    "monte carlo": "Monte Carlo",
    "ulaanbaatar": "Ulaanbaatar",
    "podgorica": "Podgorica",
    "windhoek": "Windhoek",
    "auckland": "Auckland",
    "oslo": "Oslo",
    "apia": "Apia",
    "serravalle": "Serravalle",
    "são tomé": "São Tomé",
    "belgrade": "Belgrade",
    "singapore": "Singapore",
    "philipsburg": "Philipsburg",
    "zurich": "Zurich",
    "dushanbe": "Dushanbe",
    "ashgabat": "Ashgabat",
    "beijing": "Beijing",
    "shenzhen": "Shenzhen",
    "delhi": "Delhi",
    "bangalore": "Bangalore",
    "new york city": "New York City",
    "washington dc": "Washington DC",
    "lahore": "Lahore",
    "rio de janeiro": "Rio de Janeiro",
    "st. petersberg": "St. Petersberg",
    "osaka": "Osaka",
    "alexandria": "Alexandria",
    "hanoi": "Hanoi",
    "mosul": "Mosul",
    "penang": "Penang",
    "sydney": "Sydney",
    "shenzhen": "Shenzhen",
    "bangalore": "Bangalore",
    "washington dc": "Washington DC",
  }

  const cityWelcome = {
    'houston': 'WELCOME',
    'london': 'WELCOME',
    'manila': 'MAGANDANG ARAW',
    'miami': 'WELCOME',
    'paris': 'BIENVENUE',
    'pittsburgh': 'WELCOME',
    'san-francisco': 'WELCOME',
    "shanghai": "你好",
    "taipei": "你好",
    "mumbai": "नमस्ते",
    "los angeles": "Hello",
    "jakarta": "Halo",
    "karachi": "ہیلو",
    "lagos": "Hello",
    "são paulo": "Olá",
    "dhaka": "ওহে",
    "moscow": "привет",
    "mexico city": "Hola",
    "tokyo": "こんにちは",
    "quezon city": "Kamusta",
    "addis ababa": "እው ሰላም ነው",
    "cairo": "أهلا",
    "kinshasa": "Bonjour",
    "ho chi minh city": "Xin chào",
    "tehran": "سلام",
    "istanbul": "Herhaba",
    "berlin": "Hallo",
    "paris": "Bonjour",
    "london": "Hello",
    "bangkok": "สวัสดี",
    "dar es salaam": "Jambo",
    "johannesburg": "Hello",
    "rome": "Ciao",
    "yangon": "ဟယ်လို",
    "seoul": "안녕하세요",
    "bogotá": "Hola",
    "nairobi": "Hello",
    "madrid": "Hola",
    "buenos aires": "Hola",
    "algiers": "أهلا",
    "khartoum": "أهلا",
    "kampala": "Hello",
    "baghdad": "أهلا",
    "kyiv": "привіт",
    "toronto": "Hello",
    "warsaw": "Witam",
    "marrakesh": "أهلا",
    "samarkand": "Salom",
    "riyadh": "أهلا",
    "sana'a": "أهلا",
    "lima": "Hola",
    "luanda": "Olá",
    "kabul": "سلام",
    "kuala lumpur": "Selamat petang",
    "maputo": "Olá",
    "kumasi": "Hello",
    "abidjan": "Bonjour",
    "kathmandu": "नमस्ते",
    "saint john's": "Hello",
    "yerevan": "Բարեւ Ձեզ",
    "melbourne": "Hello",
    "minsk": "привет",
    "thimphu": "སྐུ་གཟུགས་བཟང་པོ།",
    "sarajevo": "zdravo",
    "phenom penh": "សួស្តី",
    "havana": "Hola",
    "willemstad": "Hallo",
    "tbilisi": "გამარჯობა",
    "reykjavík": "Halló",
    "dublin": "Hello",
    "tel aviv": "שלום",
    "almaty": "Сәлеметсіз бе",
    "vientiane": "ສະບາຍດີ",
    "vaduz": "Hallo",
    "antananarivo": "Bonjour",
    "lilongwe": "Hello",
    "chișinău": "Buna ziua",
    "monte carlo": "Bonjour",
    "ulaanbaatar": "Сайн уу",
    "podgorica": "Здраво",
    "windhoek": "Ongaipi",
    "auckland": "Hello",
    "oslo": "Hei",
    "apia": "talofa",
    "serravalle": "Ciao",
    "são tomé": "Olá",
    "belgrade": "Здраво",
    "singapore": "Selamat petang",
    "philipsburg": "Hallo",
    "zurich": "Hallo",
    "dushanbe": "Салом",
    "ashgabat": "salam",
    "beijing": "你好",
    "shenzhen": "你好",
    "delhi": "नमस्ते",
    "bangalore": "नमस्ते",
    "new york city": "Hello",
    "washington dc": "Hello",
    "lahore": "ہیلو",
    "rio de janeiro": "Olá",
    "st. petersberg": "привет",
    "osaka": "こんにちは",
    "alexandria": "أهلا",
    "hanoi": "Xin chào",
    "mosul": "أهلا",
    "penang": "Selamat petang",
    "sydney": "Hello",
    "shenzhen": "你好",
    "bangalore": "नमस्ते",
    "washington dc": "Hello",
  }

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
  return <div style={{ marginTop: theme.spacing(5), marginLeft: isTabletOrMobile ? 20 : 200, marginRight: isTabletOrMobile ? 20 : 200, marginTop: 100 }}>
    <Helmet>
      <title>Meetup</title>
      <meta name="keywords" content="blockchain, artificial intelligence, data analysis, downloadable cloud computing software, global computer network, cryptocurrency, financial services, banking services" />
      <meta name="robots" content="noindex" />
    </Helmet>
    <BackToOnai />

    <div style={{ width: '100%', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
      <img src="/onai_text_black.png" style={{ width: isTabletOrMobile ? 50 : 100, }} />
    </div>
    {/* <StyledLink href="#privacy" title='Privacy Policy' /> | <StyledLink href="#terms" title='Terms Of Use' /> | <StyledLink href="#tm" title='Trademarks' /> */}

    {!isTabletOrMobile ?
      <Grid container spacing={2} style={{ marginTop: 50 }}>

        <Grid item xs={6}>
          <Typography variant='h2' style={sectionHeaderStyle}>{cityWelcome[city]}</Typography>
          {/* <Grid item xs={6}> */}
          <Typography style={{ fontSize: 20 }}>
            Let us know if you would like to meet with Onai&#174; {city && <>in {cityNames[city]}</>} to learn more about artificial intelligence, blockchain, cryptocurrency, Coronai&#174; compute/services, cloud computing solutions and more!
            <>{!city && <span> Select your closest city in the dropdown.</span>}</>
          </Typography>

          {/* </Grid> */}

        </Grid>

        <Grid item xs={6}>
          <FormControl fullWidth>
            <InputLabel id="city-select-label">Select City</InputLabel>
            <Select
              labelId="city-select-label"
              id="city-select"
              value={city}
              label="Select City"
              onChange={(e) => {
                setCity(e.target.value);
              }}
              placeholder='Select City'
            >
              <MenuItem value={"abidjan"}>Abidjan</MenuItem>
              <MenuItem value={"addis ababa"}>Addis Ababa</MenuItem>
              <MenuItem value={"alexandria"}>Alexandria</MenuItem>
              <MenuItem value={"algiers"}>Algiers</MenuItem>
              <MenuItem value={"almaty"}>Almaty</MenuItem>
              <MenuItem value={"antananarivo"}>Antananarivo</MenuItem>
              <MenuItem value={"apia"}>Apia</MenuItem>
              <MenuItem value={"ashgabat"}>Ashgabat</MenuItem>
              <MenuItem value={"auckland"}>Auckland</MenuItem>
              <MenuItem value={"baghdad"}>Baghdad</MenuItem>
              <MenuItem value={"bangalore"}>Bangalore</MenuItem>
              <MenuItem value={"bangkok"}>Bangkok</MenuItem>
              <MenuItem value={"beijing"}>Beijing</MenuItem>
              <MenuItem value={"belgrade"}>Belgrade</MenuItem>
              <MenuItem value={"berlin"}>Berlin</MenuItem>
              <MenuItem value={"bogotá"}>Bogotá</MenuItem>
              <MenuItem value={"buenos aires"}>Buenos Aires</MenuItem>
              <MenuItem value={"cairo"}>Cairo</MenuItem>
              <MenuItem value={"chișinău"}>Chișinău</MenuItem>
              <MenuItem value={"dar es salaam"}>Dar es Salaam</MenuItem>
              <MenuItem value={"delhi"}>Delhi</MenuItem>
              <MenuItem value={"dhaka"}>Dhaka</MenuItem>
              <MenuItem value={"dublin"}>Dublin</MenuItem>
              <MenuItem value={"dushanbe"}>Dushanbe</MenuItem>
              <MenuItem value={"hanoi"}>Hanoi</MenuItem>
              <MenuItem value={"havana"}>Havana</MenuItem>
              <MenuItem value={"ho chi minh city"}>Ho Chi Minh City</MenuItem>
              <MenuItem value={"houston"}>Houston</MenuItem>
              <MenuItem value={"istanbul"}>Istanbul</MenuItem>
              <MenuItem value={"jakarta"}>Jakarta</MenuItem>
              <MenuItem value={"johannesburg"}>Johannesburg</MenuItem>
              <MenuItem value={"kabul"}>Kabul</MenuItem>
              <MenuItem value={"kampala"}>Kampala</MenuItem>
              <MenuItem value={"karachi"}>Karachi</MenuItem>
              <MenuItem value={"kathmandu"}>Kathmandu</MenuItem>
              <MenuItem value={"khartoum"}>Khartoum</MenuItem>
              <MenuItem value={"kinshasa"}>Kinshasa</MenuItem>
              <MenuItem value={"kuala lumpur"}>Kuala Lumpur</MenuItem>
              <MenuItem value={"kumasi"}>Kumasi</MenuItem>
              <MenuItem value={"kyiv"}>Kyiv</MenuItem>
              <MenuItem value={"lagos"}>Lagos</MenuItem>
              <MenuItem value={"lahore"}>Lahore</MenuItem>
              <MenuItem value={"lilongwe"}>Lilongwe</MenuItem>
              <MenuItem value={"lima"}>Lima</MenuItem>
              <MenuItem value={"london"}>London</MenuItem>
              <MenuItem value={"los angeles"}>Los Angeles</MenuItem>
              <MenuItem value={"luanda"}>Luanda</MenuItem>
              <MenuItem value={"madrid"}>Madrid</MenuItem>
              <MenuItem value={"manila"}>Manila</MenuItem>
              <MenuItem value={"maputo"}>Maputo</MenuItem>
              <MenuItem value={"marrakesh"}>Marrakesh</MenuItem>
              <MenuItem value={"melbourne"}>Melbourne</MenuItem>
              <MenuItem value={"mexico city"}>Mexico City</MenuItem>
              <MenuItem value={"miami"}>Miami</MenuItem>
              <MenuItem value={"minsk"}>Minsk</MenuItem>
              <MenuItem value={"monte carlo"}>Monte Carlo</MenuItem>
              <MenuItem value={"moscow"}>Moscow</MenuItem>
              <MenuItem value={"mosul"}>Mosul</MenuItem>
              <MenuItem value={"mumbai"}>Mumbai</MenuItem>
              <MenuItem value={"nairobi"}>Nairobi</MenuItem>
              <MenuItem value={"new york city"}>New York City</MenuItem>
              <MenuItem value={"osaka"}>Osaka</MenuItem>
              <MenuItem value={"oslo"}>Oslo</MenuItem>
              <MenuItem value={"paris"}>Paris</MenuItem>
              <MenuItem value={"penang"}>Penang</MenuItem>
              <MenuItem value={"phenom penh"}>Phenom Penh</MenuItem>
              <MenuItem value={"philipsburg"}>Philipsburg</MenuItem>
              <MenuItem value={"pittsburgh"}>Pittsburgh</MenuItem>
              <MenuItem value={"podgorica"}>Podgorica</MenuItem>
              <MenuItem value={"quezon city"}>Quezon City</MenuItem>
              <MenuItem value={"reykjavík"}>Reykjavík</MenuItem>
              <MenuItem value={"rio de janeiro"}>Rio de Janeiro</MenuItem>
              <MenuItem value={"riyadh"}>Riyadh</MenuItem>
              <MenuItem value={"rome"}>Rome</MenuItem>
              <MenuItem value={"saint john's"}>Saint John's</MenuItem>
              <MenuItem value={"samarkand"}>Samarkand</MenuItem>
              <MenuItem value={"san-francisco"}>San Francisco</MenuItem>
              <MenuItem value={"sana'a"}>Sana'a</MenuItem>
              <MenuItem value={"são paulo"}>São Paulo</MenuItem>
              <MenuItem value={"são tomé"}>São Tomé</MenuItem>
              <MenuItem value={"sarajevo"}>Sarajevo</MenuItem>
              <MenuItem value={"seoul"}>Seoul</MenuItem>
              <MenuItem value={"serravalle"}>Serravalle</MenuItem>
              <MenuItem value={"shanghai"}>Shanghai</MenuItem>
              <MenuItem value={"shenzhen"}>Shenzhen</MenuItem>
              <MenuItem value={"singapore"}>Singapore</MenuItem>
              <MenuItem value={"st. petersberg"}>St. Petersberg</MenuItem>
              <MenuItem value={"sydney"}>Sydney</MenuItem>
              <MenuItem value={"taipei"}>Taipei</MenuItem>
              <MenuItem value={"tbilisi"}>Tbilisi</MenuItem>
              <MenuItem value={"tehran"}>Tehran</MenuItem>
              <MenuItem value={"tel aviv"}>Tel Aviv</MenuItem>
              <MenuItem value={"thimphu"}>Thimphu</MenuItem>
              <MenuItem value={"tokyo"}>Tokyo</MenuItem>
              <MenuItem value={"toronto"}>Toronto</MenuItem>
              <MenuItem value={"ulaanbaatar"}>Ulaanbaatar</MenuItem>
              <MenuItem value={"vaduz"}>Vaduz</MenuItem>
              <MenuItem value={"vientiane"}>Vientiane</MenuItem>
              <MenuItem value={"warsaw"}>Warsaw</MenuItem>
              <MenuItem value={"washington dc"}>Washington DC</MenuItem>
              <MenuItem value={"willemstad"}>Willemstad</MenuItem>
              <MenuItem value={"windhoek"}>Windhoek</MenuItem>
              <MenuItem value={"yangon"}>Yangon</MenuItem>
              <MenuItem value={"yerevan"}>Yerevan</MenuItem>
              <MenuItem value={"zurich"}>Zurich</MenuItem>
            </Select>
          </FormControl>

        </Grid>
      </Grid>
      :
      <Grid container spacing={2} style={{ marginTop: 50 }}>

        <Grid item xs={12}>
          <Typography variant='h2' style={sectionHeaderStyle}>{cityWelcome[city]}</Typography>

        </Grid>

        <Grid item xs={12}>
          <Typography style={{ fontSize: 20 }}>
            Let us know if you would like to meet Onai&#174; in {cityNames[city]} to learn more about artificial intelligence, blockchain, cryptocurrency, Coronai&#174; compute/services, cloud computing solutions and more!
          </Typography>

        </Grid>


        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel id="city-select-label">Select City</InputLabel>
            <Select
              labelId="city-select-label"
              id="city-select"
              value={city}
              label="Select City"
              onChange={(e) => {
                setCity(e.target.value);
              }}
              placeholder='Select City'
            >
              <MenuItem value={"abidjan"}>Abidjan</MenuItem>
              <MenuItem value={"addis ababa"}>Addis Ababa</MenuItem>
              <MenuItem value={"alexandria"}>Alexandria</MenuItem>
              <MenuItem value={"algiers"}>Algiers</MenuItem>
              <MenuItem value={"almaty"}>Almaty</MenuItem>
              <MenuItem value={"antananarivo"}>Antananarivo</MenuItem>
              <MenuItem value={"apia"}>Apia</MenuItem>
              <MenuItem value={"ashgabat"}>Ashgabat</MenuItem>
              <MenuItem value={"auckland"}>Auckland</MenuItem>
              <MenuItem value={"baghdad"}>Baghdad</MenuItem>
              <MenuItem value={"bangalore"}>Bangalore</MenuItem>
              <MenuItem value={"bangkok"}>Bangkok</MenuItem>
              <MenuItem value={"beijing"}>Beijing</MenuItem>
              <MenuItem value={"belgrade"}>Belgrade</MenuItem>
              <MenuItem value={"berlin"}>Berlin</MenuItem>
              <MenuItem value={"bogotá"}>Bogotá</MenuItem>
              <MenuItem value={"buenos aires"}>Buenos Aires</MenuItem>
              <MenuItem value={"cairo"}>Cairo</MenuItem>
              <MenuItem value={"chișinău"}>Chișinău</MenuItem>
              <MenuItem value={"dar es salaam"}>Dar es Salaam</MenuItem>
              <MenuItem value={"delhi"}>Delhi</MenuItem>
              <MenuItem value={"dhaka"}>Dhaka</MenuItem>
              <MenuItem value={"dublin"}>Dublin</MenuItem>
              <MenuItem value={"dushanbe"}>Dushanbe</MenuItem>
              <MenuItem value={"hanoi"}>Hanoi</MenuItem>
              <MenuItem value={"havana"}>Havana</MenuItem>
              <MenuItem value={"ho chi minh city"}>Ho Chi Minh City</MenuItem>
              <MenuItem value={"houston"}>Houston</MenuItem>
              <MenuItem value={"istanbul"}>Istanbul</MenuItem>
              <MenuItem value={"jakarta"}>Jakarta</MenuItem>
              <MenuItem value={"johannesburg"}>Johannesburg</MenuItem>
              <MenuItem value={"kabul"}>Kabul</MenuItem>
              <MenuItem value={"kampala"}>Kampala</MenuItem>
              <MenuItem value={"karachi"}>Karachi</MenuItem>
              <MenuItem value={"kathmandu"}>Kathmandu</MenuItem>
              <MenuItem value={"khartoum"}>Khartoum</MenuItem>
              <MenuItem value={"kinshasa"}>Kinshasa</MenuItem>
              <MenuItem value={"kuala lumpur"}>Kuala Lumpur</MenuItem>
              <MenuItem value={"kumasi"}>Kumasi</MenuItem>
              <MenuItem value={"kyiv"}>Kyiv</MenuItem>
              <MenuItem value={"lagos"}>Lagos</MenuItem>
              <MenuItem value={"lahore"}>Lahore</MenuItem>
              <MenuItem value={"lilongwe"}>Lilongwe</MenuItem>
              <MenuItem value={"lima"}>Lima</MenuItem>
              <MenuItem value={"london"}>London</MenuItem>
              <MenuItem value={"los angeles"}>Los Angeles</MenuItem>
              <MenuItem value={"luanda"}>Luanda</MenuItem>
              <MenuItem value={"madrid"}>Madrid</MenuItem>
              <MenuItem value={"manila"}>Manila</MenuItem>
              <MenuItem value={"maputo"}>Maputo</MenuItem>
              <MenuItem value={"marrakesh"}>Marrakesh</MenuItem>
              <MenuItem value={"melbourne"}>Melbourne</MenuItem>
              <MenuItem value={"mexico city"}>Mexico City</MenuItem>
              <MenuItem value={"miami"}>Miami</MenuItem>
              <MenuItem value={"minsk"}>Minsk</MenuItem>
              <MenuItem value={"monte carlo"}>Monte Carlo</MenuItem>
              <MenuItem value={"moscow"}>Moscow</MenuItem>
              <MenuItem value={"mosul"}>Mosul</MenuItem>
              <MenuItem value={"mumbai"}>Mumbai</MenuItem>
              <MenuItem value={"nairobi"}>Nairobi</MenuItem>
              <MenuItem value={"new york city"}>New York City</MenuItem>
              <MenuItem value={"osaka"}>Osaka</MenuItem>
              <MenuItem value={"oslo"}>Oslo</MenuItem>
              <MenuItem value={"paris"}>Paris</MenuItem>
              <MenuItem value={"penang"}>Penang</MenuItem>
              <MenuItem value={"phenom penh"}>Phenom Penh</MenuItem>
              <MenuItem value={"philipsburg"}>Philipsburg</MenuItem>
              <MenuItem value={"pittsburgh"}>Pittsburgh</MenuItem>
              <MenuItem value={"podgorica"}>Podgorica</MenuItem>
              <MenuItem value={"quezon city"}>Quezon City</MenuItem>
              <MenuItem value={"reykjavík"}>Reykjavík</MenuItem>
              <MenuItem value={"rio de janeiro"}>Rio de Janeiro</MenuItem>
              <MenuItem value={"riyadh"}>Riyadh</MenuItem>
              <MenuItem value={"rome"}>Rome</MenuItem>
              <MenuItem value={"saint john's"}>Saint John's</MenuItem>
              <MenuItem value={"samarkand"}>Samarkand</MenuItem>
              <MenuItem value={"san-francisco"}>San Francisco</MenuItem>
              <MenuItem value={"sana'a"}>Sana'a</MenuItem>
              <MenuItem value={"são paulo"}>São Paulo</MenuItem>
              <MenuItem value={"são tomé"}>São Tomé</MenuItem>
              <MenuItem value={"sarajevo"}>Sarajevo</MenuItem>
              <MenuItem value={"seoul"}>Seoul</MenuItem>
              <MenuItem value={"serravalle"}>Serravalle</MenuItem>
              <MenuItem value={"shanghai"}>Shanghai</MenuItem>
              <MenuItem value={"shenzhen"}>Shenzhen</MenuItem>
              <MenuItem value={"singapore"}>Singapore</MenuItem>
              <MenuItem value={"st. petersberg"}>St. Petersberg</MenuItem>
              <MenuItem value={"sydney"}>Sydney</MenuItem>
              <MenuItem value={"taipei"}>Taipei</MenuItem>
              <MenuItem value={"tbilisi"}>Tbilisi</MenuItem>
              <MenuItem value={"tehran"}>Tehran</MenuItem>
              <MenuItem value={"tel aviv"}>Tel Aviv</MenuItem>
              <MenuItem value={"thimphu"}>Thimphu</MenuItem>
              <MenuItem value={"tokyo"}>Tokyo</MenuItem>
              <MenuItem value={"toronto"}>Toronto</MenuItem>
              <MenuItem value={"ulaanbaatar"}>Ulaanbaatar</MenuItem>
              <MenuItem value={"vaduz"}>Vaduz</MenuItem>
              <MenuItem value={"vientiane"}>Vientiane</MenuItem>
              <MenuItem value={"warsaw"}>Warsaw</MenuItem>
              <MenuItem value={"washington dc"}>Washington DC</MenuItem>
              <MenuItem value={"willemstad"}>Willemstad</MenuItem>
              <MenuItem value={"windhoek"}>Windhoek</MenuItem>
              <MenuItem value={"yangon"}>Yangon</MenuItem>
              <MenuItem value={"yerevan"}>Yerevan</MenuItem>
              <MenuItem value={"zurich"}>Zurich</MenuItem>
            </Select>
          </FormControl>

        </Grid>
      </Grid>
    }

    <Typography style={{ ...bodyStyle, marginTop: 100 }}>
      {/* Order / Request More Information */}

      <form action='mailto:info@onai.com' method="post" enctype="text/plain" style={{ display: 'flex', flexDirection: 'column' }}>
        {/* <TextField
          placeholder='Name*'
          required
          name="name"
        />
        <Box mb={1} /> */}
        <TextField
          placeholder='E-Mail*'
          required
          name="mail"
        />
        <Box mb={1} />
        {/* <TextField
          placeholder='Organization'
          name="organization"
        /> */}
        {/* <Box mb={1} />
        <TextField
          placeholder='Phone Number'
          name='ph'
        /> */}
        <Box mb={1} />
        <TextField
          placeholder='Subject*'
          name='subject'
          required
        />
        <Box mb={1} />
        <TextField
          placeholder='Query'
          multiline
          rows={4}
        />
        <Box mb={1} />
        <Button
          type="submit"
          variant='contained'
          color='inherit'
          style={{ display: 'flex', alignSelf: 'center' }}
        >
          Submit
        </Button>
      </form>
    </Typography>

  </div >
}

function CareersMobile() {
  return <div>
    <Typography variant='h1' style={sectionHeaderStyle}>CAREERS</Typography>
    <Grid container spacing={1} style={{ width: '100%', paddingLeft: 30, paddingRight: 30 }}>
      <Grid item xs={12}>
        <Paper elevation={3} style={{
          height: 200,
          padding: theme.spacing(2)
        }}>
          <Typography variant="button" style={subHeaderStyle}>Lemonade Stand Manager</Typography>
          <Typography style={bodyStyle}>
            Citric Engineering
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper elevation={3} style={{
          height: 200,
          padding: theme.spacing(2)
        }}>
          <Typography variant="button" style={subHeaderStyle}>Tractor Designer</Typography>
          <Typography style={bodyStyle}>
            Farmland
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper elevation={3} style={{
          height: 200,
          padding: theme.spacing(2)
        }}>
          <Typography variant="button" style={subHeaderStyle}>Mechanical Engineering</Typography>
          <Typography style={bodyStyle}>
            Cars
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  </div>
}

function Legal() {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
  return <div style={{ marginTop: theme.spacing(5), marginLeft: isTabletOrMobile ? 20 : 200, marginRight: isTabletOrMobile ? 20 : 200, marginTop: 100 }}>
    <BackToOnai />
    <Typography variant='h2' style={sectionHeaderStyle}>POLICIES</Typography>
    <StyledLink href="#privacy" title='Privacy Policy' /> | <StyledLink href="#terms" title='Terms Of Use' /> | <StyledLink href="#tm" title='Trademarks' />

    <Typography variant='h3' id="privacy" style={{ ...subHeaderStyle, display: 'block', marginTop: theme.spacing(5) }} component='div'>Privacy Policy</Typography>
    <Typography style={bodyStyle}>
      Additional information on privacy rights are available further down this page. <StyledLink href="#caprivacy" title='Click here to jump to it.' />
      <p>The Onai website (including all websites to which this Privacy Policy is posted, the <strong>“Site”</strong>), which is operated by Onai Inc.
        (“<strong>Onai</strong>,” “<strong>we</strong>”, “<strong>us</strong>” and/or “<strong>our</strong>”). This Site provides, among other things,
        the ability to obtain information about our products, services, and company (all that the site provides is collectively the “<strong>Service</strong>”).</p>
      <p>This Privacy Policy explains what Personal Information (defined below) we collect, how we use and share that data, and your choices concerning our data practices.
        This Privacy Policy is incorporated into and forms part of our <StyledLink href="https://www.onai.com/legal#terms" title='Terms of Service' />.</p>
      <p>Before using the Service or submitting any Personal Information to Onai, please review this Privacy Policy carefully and contact us
        if you have any questions. By using the Service, you agree to the practices described in this Privacy Policy. If you do not agree to
        this Privacy Policy, please do not access the Site or otherwise use the Service.</p>
    </Typography>

    <Typography variant='h4' id="section1">1.  PERSONAL INFORMATION WE COLLECT</Typography>
    <Typography style={bodyStyle}>
      <p>We collect information that alone or in combination with other information in our possession could be used to identify you (“<strong>Personal Information</strong>”) as follows:</p>
      <p><strong>Personal Information You Provide</strong>: We may collect Personal Information when you submit an inquiry through a form on the Site or email us.</p>
      <p><strong>Personal Information We Collect Through Our Social Media Pages</strong>: We may have pages on social media sites like Instagram, Facebook, Medium, Twitter, YouTube and LinkedIn (“<strong>Social Media Pages</strong>”). When you interact with our Social Media Pages, we will collect Personal Information that you elect to provide to us, such as your contact details (“<strong>Social Information</strong>”). In addition, the companies that host our Social Media Pages may provide us with aggregate information and analytics regarding the use of our Social Media Pages.</p>
      <p><strong>Personal Information We Receive Automatically From Your Use of the Service</strong>: When you visit, use, and interact with the Service, we may receive certain information about your visit, use, or interactions (“<strong>Technical Information</strong>”). For example, we may monitor the number of people that visit the Service, peak hours of visits, which page(s) are visited, the domains our visitors come from (e.g., google.com, yahoo.com, etc.), and which browsers people use to access the Service (e.g., Chrome, Firefox, Microsoft Internet Explorer, etc.), broad geographical information, and navigation pattern. In particular, Technical Information includes the following, which is created and automatically logged in our systems:</p>
      <ul>
        <li>
          <p>Log data: Information that your browser automatically sends whenever you visit the Site (“<strong>log data</strong>”). Log data includes your Internet Protocol address, browser type and settings, the date and time of your request, and how you interacted with the Site.</p>
        </li>
        <li>
          <p>Cookies: See the “Cookies” section below to learn more about how we use cookies.</p>
        </li>
        <li>
          <p>Device information: Includes name of the device, operating system, and browser you are using. Information collected may depend on the type of device you use and its settings.</p>
        </li>
        <li>
          <p>Usage Information: We collect information about how you use our Service, such as the types of content that you view or engage with, the features you use, the actions you take, and the time, frequency, and duration of your activities.</p>
        </li>
      </ul>
      <p><strong>Cookies</strong>: We may from time to time use cookies to operate and administer our Site, gather usage data on our Site, and improve your experience on it. A “cookie” is a piece of information sent to your browser by a website you visit. Cookies can be stored on your computer for different periods of time. Some cookies expire after a certain amount of time, or upon logging out (session cookies), others survive after your browser is closed until a defined expiration date set in the cookie (as determined by the third party placing it), and help recognize your computer when you open your browser and browse the Internet again (persistent cookies).
        For more details on cookies please visit <StyledLink href="http://www.allaboutcookies.org/" title='All About Cookies' /></p>
      <p><strong>Analytics</strong>: We do not use Google Analytics or other analytics services that utilize cookies.</p>
      <p><strong>Online Tracking and Do Not Track Signals</strong>: Our Site currently does not respond to “Do Not Track” (“DNT”) signals and operates as described in this Privacy Policy whether or not a DNT signal is received. </p>
      <p><strong>Your Choices</strong>. On most web browsers, you will find a “help” section on the toolbar. Please refer to this section for information on how to receive a notification when you are receiving a new cookie and how to turn cookies off. Please see the links below for guidance on how to modify your web browser’s settings on the most popular browsers:</p>
      <ul>
        <li>
          <p><StyledLink href="http://windows.microsoft.com/en-gb/internet-explorer/delete-manage-cookies#ie=ie-11" title='Internet Explorer' /></p>
        </li>
        <li>
          <p><StyledLink href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences?esab=a&amp;s=cookies&amp;r=6&amp;as=s" title='Mozilla Firefox' /></p>
        </li>
        <li>
          <p><StyledLink href="https://support.google.com/accounts/answer/61416?hl=en" title='Google Chrome' /></p>
        </li>
        <li>
          <p><StyledLink href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac" title='Apple Safari' /></p>
        </li>
      </ul>
      <p>Please note that if you limit the ability of websites to set cookies, you may be unable to access certain parts of the Site and you may not be able to benefit from the full functionality of the Site.</p>
      <p>We do not have any third party advertising on our site but note here that advertising networks may use cookies to collect Personal Information. Most advertising networks offer you a way to opt out of targeted advertising. If you would like to find out more information, please visit the Network Advertising Initiative’s online resources at <StyledLink href="http://www.networkadvertising.org" title='http://www.networkadvertising.org' /> and follow the opt-out instructions there.</p>
      <p>If you access the Site on your mobile device, you may not be able to control tracking technologies through the settings.</p>
    </Typography>
    <Typography variant='h4'>2.  HOW WE USE PERSONAL INFORMATION</Typography>
    <Typography style={bodyStyle}>
      <p>We may use Personal Information for the following purposes:</p>
      <ul>
        <li>
          <p>To provide and administer access to the Service;</p>
        </li>
        <li>
          <p>To respond to your inquiries, comments, feedback, or questions;</p>
        </li>
        <li>
          <p>To send administrative information to you, for example, information regarding the Service and changes to our terms, conditions, and policies;</p>
        </li>
        <li>
          <p>To analyze how you interact with our Service;</p>
        </li>
        <li>
          <p>To maintain and improve the content and functionality of the Service;</p>
        </li>
        <li>
          <p>To develop new programs and services;</p>
        </li>
        <li>
          <p>To prevent fraud, criminal activity, or misuses of our Service, and to ensure the security of our IT systems, architecture, and networks; and</p>
        </li>
        <li>
          <p>To comply with legal obligations and legal process and to protect our rights, privacy, safety, or property, and/or that of our affiliates, you, or other third parties.</p>
        </li>
      </ul>
      <p><strong>Aggregated Information</strong>. We may aggregate Personal Information and use the aggregated information to analyze the effectiveness of our Service, to improve and add features to our Service, and for other similar purposes. In addition, from time to time, we may analyze the general behavior and characteristics of users of our Services and share aggregated information like general user statistics with prospective business partners. We may collect aggregated information through the Service, through cookies, and through other means described in this Privacy Policy.</p>
    </Typography>
    <Typography variant='h4'>3.  SHARING AND DISCLOSURE OF PERSONAL INFORMATION</Typography>
    <Typography style={bodyStyle}>
      <p>In certain circumstances we may share your Personal Information with third parties without further notice to you, unless required by the law, as set forth below:</p>
      <ul>
        <li>
          <p><strong>Vendors and Service Providers</strong>: To assist us in meeting business operations needs and to perform certain services and functions, we may share Personal Information with vendors and service providers, including providers of hosting services, cloud services, and other information technology services providers, event management services, email communication software and email newsletter services, advertising and marketing services, and web analytics services. Pursuant to our instructions, these parties will access, process, or store Personal Information in the course of performing their duties to us.</p>
        </li>
        <li>
          <p><strong>Business Transfers</strong>: If we are involved in a merger, acquisition, financing due diligence, reorganization, bankruptcy, receivership, sale of all or a portion of our assets, or transition of service to another provider (collectively a “Transaction”), your Personal Information and other information may be shared in the diligence process with counterparties and others assisting with the Transaction and transferred to a successor or affiliate as part of that Transaction along with other assets.</p>
        </li>
        <li>
          <p><strong>Legal Requirements</strong>: If required to do so by law or in the good faith belief that such action is necessary to (i) comply with a legal obligation, including to meet national security or law enforcement requirements, (ii) protect and defend our rights or property, (iii) prevent fraud, (iv) act in urgent circumstances to protect the personal safety of users of the Services, or the public, or (v) protect against legal liability.</p>
        </li>
        <li>
          <p><strong>Affiliates</strong>: We may share Personal Information with our affiliates, meaning an entity that controls, is controlled by, or is under common control with Onai. Our affiliates may use the Personal Information we share in a manner consistent with this Privacy Policy.</p>
        </li>
      </ul>
    </Typography>
    <Typography variant='h4'>4.  UPDATE YOUR INFORMATION</Typography>
    <Typography style={bodyStyle}>
      <p>To update information you have provided or if you have questions about this Privacy Policy, please email info@onai.com.</p>
    </Typography>
    <Typography variant='h4'>5.  CALIFORNIA PRIVACY RIGHTS</Typography>
    <Typography style={bodyStyle}>
      <p>The following disclosures are intended to provide additional information about (1) the categories of Personal Information we collect (as defined in <a href="#section1">Section 1</a>), (2) the source of the Personal Information, (3) how we use each category of Personal Information, and (4) how we disclose Personal Information. These disclosures do not limit our ability to use or disclose information as described in Sections 2 and 3.</p>
      <table id="privacy_info">
        <thead>
          <tr>
            <td>Category of Personal Information</td>
            <td>Sources Of Personal Information</td>
            <td>Use of Personal Information</td>
            <td>Disclosure of Personal Information</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Inquiries</td>
            <td>We collect inquiry information directly from you.</td>
            <td>We use inquiry information to respond to your inquiry and potentially for internal training or resources.</td>
            <td>We may disclose inquiry information to our affiliates and/or communication service providers.</td>
          </tr>
          <tr>
            <td>Social Information</td>
            <td>We collect Social Information from you when you interact with our Social Media Pages.</td>
            <td>We use Social Information to perform analytics and to communicate with you.</td>
            <td>We may disclose Social Information to our affiliates.</td>
          </tr>
          <tr>
            <td>Technical Information</td>
            <td>We collect Technical Information from you.</td>
            <td>We use Technical Information for analytics and in some cases, for prevention of fraud and malicious activity by users of our Services.</td>
            <td>We disclose Technical Information to our affiliates.</td>
          </tr>
        </tbody>
      </table>
      <p><br /> <br /></p>
      <p><u id="calprivacy"><strong>California Privacy Rights</strong></u></p>
      <p>To the extent provided for by law and subject to applicable exceptions, California residents have the following privacy rights in relation to the Personal Information we collect:</p>
      <ul>
        <li>
          <p>The right to know what Personal Information we have collected and how we have used and disclosed that Personal Information;</p>
        </li>
        <li>
          <p>The right to request deletion of your Personal Information; and</p>
        </li>
        <li>
          <p>The right to be free from discrimination relating to the exercise of any of your privacy rights.</p>
        </li>
      </ul>
      <p><strong>We do not sell your Personal Information.</strong></p>
      <p><strong>Exercising Your Rights</strong>: California residents can exercise the above privacy rights by emailing the Onai team at info@onai.com.</p>
      <p><strong>Verification</strong>: in order to protect your Personal Information from unauthorized access or deletion, we may require you to verify your identity before you can submit a request to know or delete Personal Information. If we suspect fraudulent or malicious activity, we may ask you to provide additional Personal Information for verification that the request is coming from the person whose Personal Information is held. If we cannot verify your identity, we will not provide or delete your Personal Information.</p>
      <p><strong>Authorized Agents</strong>: you may submit a request to know or a request to delete your Personal Information through an authorized agent. If you do so, the agent must present signed written permission to act on your behalf and you may also be required to independently verify your identity and submit proof of your residency with us.</p>
    </Typography>
    <Typography variant='h4'>6.  CHILDREN</Typography>
    <Typography style={bodyStyle}>
      <p>Our Service is not directed to children who are under the age of 13. Onai does not knowingly collect Personal Information from children under the age of 13. If you have reason to believe that a child under the age of 13 has provided Personal Information to Onai through the Service, please email info@onai.com and we will endeavor to delete that information.</p>
    </Typography>
    <Typography variant='h4'>7.  LINKS TO OTHER WEBSITES</Typography>
    <Typography style={bodyStyle}>
      <p>The Service may contain links to other websites not operated or controlled by Onai, including social media services (“<strong>Third Party Sites</strong>”). The information that you share with Third Party Sites will be governed by the specific privacy policies and terms of service of the Third Party Sites and not by this Privacy Policy. By providing these links we do not imply that we endorse or have reviewed these sites. Please contact the Third Party Sites directly for information on their privacy practices and policies.</p>
    </Typography>
    <Typography variant='h4'>8.  SECURITY</Typography>
    <Typography style={bodyStyle}>
      <p>You use the Service at your own risk. We implement commercially reasonable technical, administrative, and organizational measures to protect Personal Information both online and offline from loss, misuse, and unauthorized access, disclosure, alteration, or destruction. However, no Internet or e-mail transmission is ever fully secure or error free. In particular, e-mail sent to or from us may not be secure. Therefore, you should take special care in deciding what information you send to us via the Service or e-mail. Please keep this in mind when disclosing any Personal Information to Onai via the Internet. In addition, we are not responsible for circumvention of any privacy settings or security measures contained on the Service, or third party websites.</p>
    </Typography>
    <Typography variant='h4'>9.  INTERNATIONAL USERS</Typography>
    <Typography style={bodyStyle}>
      <p>By using our Service, you understand and acknowledge that your Personal Information will be transferred from your location to our facilities and servers in the United States.</p>
    </Typography>
    <Typography variant='h4'>10. YOUR CHOICES</Typography>
    <Typography style={bodyStyle}>
      <p>In certain circumstances providing Personal Information is optional. However, if you choose not to provide Personal Information that is needed to use some features of our Service, you may be unable to use those features. You can also contact us at info@onai.com to ask us to update or correct your Personal Information.</p>
    </Typography>
    <Typography variant='h4'>11. CHANGES TO THE PRIVACY POLICY</Typography>
    <Typography style={bodyStyle}>
      <p>The Service and our business may change from time to time. As a result we may change this Privacy Policy at any time. When we do we will post an updated version on this page, unless another type of notice is required by the applicable law. By continuing to use our Service or providing us with Personal Information after we have posted an updated Privacy Policy, or notified you by other means if applicable, you consent to the revised Privacy Policy and practices described in it.</p>
    </Typography>
    <Typography variant='h4'>12. QUESTIONS ABOUT THE PRIVACY POLICY</Typography>
    <Typography style={bodyStyle}>
      <p>If you have any questions about our Privacy Policy or information practices or need to access this Privacy Policy in a different format, please feel free to contact the legal team at our designated request address info@onai.com.</p>
    </Typography>
    <Typography variant='h4'>Terms Of Use</Typography>
    <Typography style={bodyStyle}>
      <h3 id="terms"></h3><p>The Onai website (including all subdomains, the “<strong>Site</strong>”) is operated by Onai Inc. and its affiliates (collectively, “<strong>Onai</strong>,” “<strong>we</strong>”, “<strong>us</strong>” and/or “<strong>our</strong>”). This Site provides, among other things, the ability to obtain information about our products, services, and company (all that the site provides is collectively the “<strong>Service</strong>”).</p>
      <p><i><strong>THESE TERMS OF USE CONTAIN AN ARBITRATION AGREEMENT, WHICH WILL, WITH LIMITED EXCEPTION, REQUIRE YOU TO SUBMIT CLAIMS YOU HAVE AGAINST US TO BINDING AND FINAL ARBITRATION.  UNDER THE ARBITRATION AGREEMENT, (1) YOU WILL ONLY BE PERMITTED TO PURSUE CLAIMS AGAINST ONAI ON AN INDIVIDUAL BASIS, NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY CLASS OR REPRESENTATIVE ACTION OR PROCEEDING, AND (2) YOU WILL ONLY BE PERMITTED TO SEEK RELIEF (INCLUDING MONETARY, INJUNCTIVE, AND DECLARATORY RELIEF) ON AN INDIVIDUAL BASIS</strong></i></p>
      <p>We reserve the right, at our sole discretion, to change or modify portions of these Terms of Use at any time.  If we do this, we will post the changes on this page and will indicate at the top of this page the date these terms were last revised. We will also notify you, either through the Site user interface, in an email notification or through other reasonable means. Any such changes will become effective no earlier than fourteen (14) days after they are posted, except that changes addressing new functions of the Site or changes made for legal reasons will be effective immediately. Your continued use of the Site after the date any such changes become effective constitutes your acceptance of the new Terms of Use.</p>
      <p>In addition, when using certain components of the Site, you will be subject to any additional terms, policies, rules or guidelines applicable to the Site or such components of the Site that may be posted on the Site from time to time, including, without limitation, the Privacy Policy located at <a href="#privacy">www.onai.com/legal#privacy</a>.  All such terms are hereby incorporated by reference into these Terms of Use.</p>
      <p><br /><br />
        <u><strong>Access and Use of the Site</strong></u></p>
      <p><strong>Modifications to Site</strong>: Onai reserves the right to modify or discontinue, temporarily or permanently, the Site (or any part thereof) with or without notice. You agree that Onai will not be liable to you or to any third party for any modification, suspension or discontinuance of the Site.</p>
      <p><strong>General Practices Regarding Use and Storage</strong>: You acknowledge that Onai may establish general practices and limits concerning use of the Site, including without limitation the maximum period of time that data or other content will be retained by the Site and the maximum storage space that will be allotted on Onai's servers or the servers of Onai's vendors on your behalf. You agree that Onai has no responsibility or liability for the deletion or failure to store any data or other content maintained or uploaded by the Site. You further acknowledge that Onai reserves the right to change these general practices and limits at any time, in its sole discretion, with or without notice.</p>
      <p><br /><br />
        <u><strong>Conditions Of Use</strong></u></p>
      <p><strong>User Conduct</strong>: In addition to any applicable guidelines or policies that may govern specific components of the Site, you agree to comply with the following conditions in using the Site.  You are solely responsible for all code, video, images, information, data, text, software, music, sound, photographs, graphics, messages or other materials (“content”) that you upload, post, publish or display (hereinafter, “upload”) or email or otherwise transmit via the Site.  The following are examples of the kind of content and/or use that is illegal or prohibited by Onai.  Onai reserves the right to investigate and take appropriate legal action against anyone who, in Onai’s sole discretion, violates this provision, including without limitation, removing the offending content from the Site, suspending or terminating the account of such violators and reporting you to the law enforcement authorities.  You agree to not use the Site to:</p>
      <ul>
        <li>email or otherwise upload any content that (i) infringes any intellectual property or other proprietary rights of any party; (ii) you do not have a right to upload under any law or under contractual or fiduciary relationships; (iii) contains software viruses or any other computer code, files or programs designed to interrupt, destroy or limit the functionality of any computer software or hardware or telecommunications equipment; (iv) poses or creates a privacy or security risk to any person; (v) constitutes unsolicited or unauthorized advertising, promotional materials, commercial activities and/or sales, “junk mail,” “spam,” “chain letters,” “pyramid schemes,” “contests,” “sweepstakes,” or any other form of solicitation; (vi) is unlawful, harmful, threatening, abusive, harassing, tortious, excessively violent, defamatory, vulgar, obscene, pornographic, libelous, invasive of another’s privacy, hateful racially, ethnically or otherwise objectionable; or (vii) in the sole judgment of Onai, is objectionable or which restricts or inhibits any other person from using or enjoying the Site, or which may expose Onai or its users to any harm or liability of any type;</li>
        <li>interfere with or disrupt the Site or servers or networks connected to the Site, or disobey any requirements, procedures, policies or regulations of networks connected to the Site;</li>
        <li>violate any applicable local, state, national or international law, or any regulations having the force of law;</li>
        <li>impersonate any person or entity, or falsely state or otherwise misrepresent your affiliation with a person or entity;</li>
        <li>solicit personal information from anyone under the age of 18;</li>
        <li>harvest or collect personal information of other users from the Site by electronic or other means for the purposes of sending unsolicited emails or other unsolicited communications;</li>
        <li>advertise or offer to sell or buy any goods or services for any business purpose that is not specifically authorized;</li>
        <li>further or promote any criminal activity or enterprise or provide instructional information about illegal activities; or</li>
        <li>obtain or attempt to access or otherwise obtain any materials or information through any means not intentionally made available or provided for through the Site.</li>
      </ul>
      <p><strong>Commercial Use</strong>: Unless otherwise expressly authorized herein or in the Site, you agree not to display, distribute, license, perform, publish, reproduce, duplicate, copy, create derivative works from, modify, sell, resell, exploit, transfer or upload for any commercial purposes, any portion of the Site, use of the Site, or access to the Site.
      </p>
      <p><br /><br />
        <u><strong>Intellectual Property Rights</strong></u></p>
      <p><strong>Site Content, Software and Trademarks</strong>: You acknowledge and agree that the Site may contain content or features (“Site Content”) that are protected by copyright, patent, trademark, trade secret or other proprietary rights and laws.  Except as expressly authorized by Onai, you agree not to modify, copy, frame, scrape, rent, lease, loan, sell, distribute or create derivative works based on the Site or the Site Content, in whole or in part.  If you are blocked by Onai from accessing the Site (including by blocking your IP address), you agree not to implement any measures to circumvent such blocking (e.g., by masking your IP address or using a proxy IP address).  Any use of the Site or the Site Content other than as specifically authorized herein is strictly prohibited.  Any rights not expressly granted herein are reserved by Onai.</p>
      <p>The Onai name and logos are trademarks of Onai (collectively the “Onai Trademarks”). Other trademarks used and displayed via the Site may be trademarks of their respective owners who may or may not endorse or be affiliated with or connected to Onai. Nothing in this Terms of Use or the Site should be construed as granting, by implication, estoppel, or otherwise, any license or right to use any of Onai Trademarks displayed on the Site, without our prior written permission in each instance. All goodwill generated from the use of Onai Trademarks will inure to our exclusive benefit.</p>
      <p><strong>Third Party Material</strong>:  Under no circumstances will Onai be liable in any way for any content or materials of any third parties, including, but not limited to, for any errors or omissions in any content, or for any loss or damage of any kind incurred as a result of the use of any such content. You agree that you must evaluate, and bear all risks associated with, the use of any content, including any reliance on the accuracy, completeness, or usefulness of such content.</p>
      <p><strong>User Content Transmitted Through the Site</strong>: With respect to the content or other materials you upload through the Site or share with other users or recipients (collectively, “User Content”), you represent and warrant that you own all right, title and interest in and to such User Content, including, without limitation, all copyrights and rights of publicity contained therein.  By uploading any User Content you hereby grant and will grant Onai and its affiliated companies a nonexclusive, worldwide, royalty free, fully paid up, transferable, sublicensable, perpetual, irrevocable license to copy, display, upload, perform, distribute, store, modify and otherwise use your User Content for any Onai-related purpose in any form, medium or technology now known or later developed. </p>
      <p>You acknowledge and agree that any questions, comments, suggestions, ideas, feedback or other information about the Site (“Submissions”) provided by you to Onai are non-confidential and Onai will be entitled to the unrestricted use and dissemination of these Submissions for any purpose, without acknowledgment or compensation to you.</p>
      <p>Without limiting the foregoing, you acknowledge and agree that Onai may preserve content and may also disclose content if required to do so by law or in the good faith belief that such preservation or disclosure is reasonably necessary to: (a) comply with legal process, applicable laws or government requests; (b) enforce these Terms of Use; (c) respond to claims that any content violates the rights of third parties; or (d) protect the rights, property, or personal safety of Onai, its users and the public. You understand that the technical processing and transmission of the Site, including your content, may involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices.</p>
      <u><strong>Third Party Websites</strong></u>

      <p>The Site may provide, or third parties may provide, links or other access to other sites and resources on the Internet or to third party applications. Onai has no control over such sites, resources or applications and Onai is not responsible for and does not endorse such sites, resources or applications.  You further acknowledge and agree that Onai will not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any content, events, goods or services available on or through any such sites, resources or applications.   Any dealings you have with third parties found while using the Site are between you and the third party, and you agree that Onai is not liable for any loss or claim that you may have against any such third party.</p>
      <p><br /><br />
        <u><strong>Indemnity and Release</strong></u></p>
      <p>You agree to release, indemnify and hold Onai and its affiliates and their officers, employees, directors and agents harmless from any from any and all losses, damages, expenses, including reasonable attorneys’ fees, rights, claims, actions of any kind and injury (including death) arising out of or relating to your use of the Site or any related information, your violation of these Terms of Use or your violation of any rights of another.  If you are a California resident, you waive California Civil Code Section 1542, which says: “A general release does not extend to claims which the creditor does not know or suspect to exist in his favor at the time of executing the release, which if known by him must have materially affected his settlement with the debtor.” If you are a resident of another jurisdiction, you waive any comparable statute or doctrine.</p>
      <p><br /><br />
        <u><strong>Disclaimer of Warranties</strong></u></p>
      <p>YOUR USE OF THE SITE IS AT YOUR SOLE RISK. THE SITE IS PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS. Onai EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED OR STATUTORY, INCLUDING, BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT.</p>
      <p>Onai MAKES NO WARRANTY THAT (I) THE SITE WILL MEET YOUR REQUIREMENTS, (II) THE SITE WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE, OR (III) THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SITE WILL BE ACCURATE OR RELIABLE.</p>
      <p><br /><br />
        <u><strong>Limitation of Liability</strong></u>
        YOU EXPRESSLY UNDERSTAND AND AGREE THAT Onai WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY DAMAGES, OR DAMAGES FOR LOSS OF PROFITS INCLUDING BUT NOT LIMITED TO, DAMAGES FOR LOSS OF GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES (EVEN IF Onai HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), WHETHER BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, RESULTING FROM: (I) THE USE OR THE INABILITY TO USE THE SITE OR ANY RELATED INFORMATION; (II) UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA; (III) STATEMENTS OR CONDUCT OF ANY THIRD PARTY (INCLUDING USERS) ON THE SITE; OR (IV) ANY OTHER MATTER RELATING TO THE SITE. IN NO EVENT WILL Onai’S TOTAL LIABILITY TO YOU FOR ALL DAMAGES, LOSSES OR CAUSES OF ACTION EXCEED ONE HUNDRED DOLLARS ($100).</p>
      <p>SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR EXCLUSION OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES. ACCORDINGLY, SOME OF THE ABOVE LIMITATIONS SET FORTH ABOVE MAY NOT APPLY TO YOU. IF YOU ARE DISSATISFIED WITH ANY PORTION OF THE SITE OR WITH THESE TERMS OF USE, YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE USE OF THE SITE.</p>
      <p>WITHOUT LIMITING THE FOREGOING, IF YOU ARE A USER FROM NEW JERSEY, THE ‘DISCLAIMER OF WARRANTIES’ AND ‘LIMITATION OF LIABILITY’ SECTIONS ABOVE ARE INTENDED TO BE ONLY AS BROAD AS IS PERMITTED UNDER NEW JERSEY LAW. IF ANY PORTION OF THESE SECTIONS IS HELD TO BE INVALID UNDER NEW JERSEY LAW, THE INVALIDITY OF SUCH PORTION SHALL NOT AFFECT THE VALIDITY OF THE REMAINING PORTIONS OF THE APPLICABLE SECTION.</p>
      <p><br /><br />
        <strong><u>Dispute Resolution By Binding Arbitration</u>: PLEASE READ THIS SECTION CAREFULLY AS IT AFFECTS YOUR RIGHTS.</strong></p>
      <p><strong>a. Agreement to Arbitrate</strong></p>
      <p>This Dispute Resolution by Binding Arbitration section is referred to in this Terms of Use as the “Arbitration Agreement.”  You agree that any and all disputes or claims that have arisen or may arise between you and Onai, whether arising out of or relating to this Terms of Use (including any alleged breach thereof), the Site, any advertising, any aspect of the relationship or transactions between us, shall be resolved exclusively through final and binding arbitration, rather than a court, in accordance with the terms of this Arbitration Agreement, except that you may assert individual claims in small claims court, if your claims qualify.  Further, this Arbitration Agreement does not preclude you from bringing issues to the attention of federal, state, or local agencies, and such agencies can, if the law allows, seek relief against us on your behalf.  You agree that, by entering into this Terms of Use, you and Onai are each waiving the right to a trial by jury or to participate in a class action.  Your rights will be determined by a neutral arbitrator, not a judge or jury.  The Federal Arbitration Act governs the interpretation and enforcement of this Arbitration Agreement.</p>
      <p><strong>b. Prohibition of Class and Representative Actions and Non-Individualized Relief</strong></p>
      <p><i><strong>YOU AND Onai AGREE THAT EACH OF US MAY BRING CLAIMS AGAINST THE OTHER ONLY ON AN INDIVIDUAL BASIS AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE ACTION OR PROCEEDING.  UNLESS BOTH YOU AND Onai AGREE OTHERWISE, THE ARBITRATOR MAY NOT CONSOLIDATE OR JOIN MORE THAN ONE PERSON’S OR PARTY’S CLAIMS AND MAY NOT OTHERWISE PRESIDE OVER ANY FORM OF A CONSOLIDATED, REPRESENTATIVE, OR CLASS PROCEEDING.  ALSO, THE ARBITRATOR MAY AWARD RELIEF (INCLUDING MONETARY, INJUNCTIVE, AND DECLARATORY RELIEF) ONLY IN FAVOR OF THE INDIVIDUAL PARTY SEEKING RELIEF AND ONLY TO THE EXTENT NECESSARY TO PROVIDE RELIEF NECESSITATED BY THAT PARTY’S INDIVIDUAL CLAIM(S).</strong></i></p>
      <p><strong>c. Pre-Arbitration Dispute Resolution</strong></p>
      <p>Onai is always interested in resolving disputes amicably and efficiently, and most user concerns can be resolved quickly and to the user’s satisfaction by emailing us at info@onai.com.  If such efforts prove unsuccessful, a party who intends to seek arbitration must first send to the other, by certified mail, a written Notice of Dispute (“Notice”).  The Notice to Onai should be sent to Onai, 7291 Coronado Dr., Suite 5, San Jose, CA 95129 Attention Legal (“Notice Address”).  The Notice must (i) describe the nature and basis of the claim or dispute and (ii) set forth the specific relief sought.  If Onai and you do not resolve the claim within sixty (60) calendar days after the Notice is received, you or Onai may commence an arbitration proceeding.  During the arbitration, the amount of any settlement offer made by Onai or you shall not be disclosed to the arbitrator until after the arbitrator determines the amount, if any, to which you or Onai is entitled.</p>
      <p><strong>d. Arbitration Procedures</strong></p>
      <p>Arbitration will be conducted by a neutral arbitrator in accordance with the American Arbitration Association’s (“AAA”) rules and procedures (collectively, the “AAA Rules”), as modified by this Arbitration Agreement.  For information on the AAA, please visit its website, http://www.adr.org.  If there is any inconsistency between any term of the AAA Rules and any term of this Arbitration Agreement, the applicable terms of this Arbitration Agreement will control unless the arbitrator determines that the application of the inconsistent Arbitration Agreement terms would not result in a fundamentally fair arbitration.  The arbitrator must also follow the provisions of these Terms of Use as a court would.  All issues are for the arbitrator to decide, including, but not limited to, issues relating to the scope, enforceability, and arbitrability of this Arbitration Agreement.  Although arbitration proceedings are usually simpler and more streamlined than trials and other judicial proceedings, the arbitrator can award the same damages and relief on an individual basis that a court can award to an individual under the Terms of Use and applicable law.  Decisions by the arbitrator are enforceable in court and may be overturned by a court only for very limited reasons.</p>
      <p>Unless Onai and you agree otherwise, any arbitration hearings will take place in a reasonably convenient location for both parties with due consideration of their ability to travel and other pertinent circumstances.  If the parties are unable to agree on a location, the determination shall be made by AAA.  If your claim is for $10,000 or less, Onai agrees that you may choose whether the arbitration will be conducted solely on the basis of documents submitted to the arbitrator, through a telephonic hearing, or by an in-person hearing as established by the AAA Rules.  If your claim exceeds $10,000, the right to a hearing will be determined by the AAA Rules.  Regardless of the manner in which the arbitration is conducted, the arbitrator shall issue a reasoned written decision sufficient to explain the essential findings and conclusions on which the award is based.</p>
      <p><strong>e. Costs of Arbitration</strong></p>
      <p>Payment of all filing, administration, and arbitrator fees (collectively, the “Arbitration Fees”) will be governed by the AAA Rules, unless otherwise provided in this Arbitration Agreement.</p>
      <p><strong>f. Confidentiality</strong></p>
      <p>All aspects of the arbitration proceeding, and any ruling, decision, or award by the arbitrator, will be strictly confidential for the benefit of all parties.</p>
      <p><strong>g. Severability</strong></p>
      <p>If a court or the arbitrator decides that any term or provision of this Arbitration Agreement (other than the subsection (b) titled “Prohibition of Class and Representative Actions and Non-Individualized Relief” above) is invalid or unenforceable, the parties agree to replace such term or provision with a term or provision that is valid and enforceable and that comes closest to expressing the intention of the invalid or unenforceable term or provision, and this Arbitration Agreement shall be enforceable as so modified.  If a court or the arbitrator decides that any of the provisions of subsection (b) above titled “Prohibition of Class and Representative Actions and Non-Individualized Relief” are invalid or unenforceable, then the entirety of this Arbitration Agreement shall be null and void.  The remainder of the Terms of Use will continue to apply.</p>
      <p><strong>h. Future Changes to Arbitration Agreement</strong></p>
      <p>Notwithstanding any provision in this Terms of Use to the contrary, Onai agrees that if it makes any future change to this Arbitration Agreement (other than a change to the Notice Address) while you are a user of the Site, you may reject any such change by sending Onai written notice within thirty (30) calendar days of the change to the Notice Address provided above.  By rejecting any future change, you are agreeing that you will arbitrate any dispute between us in accordance with the language of this Arbitration Agreement as of the date you first accepted these Terms of Use (or accepted any subsequent changes to these Terms of Use).</p>
      <p><br /><br />
        <u><strong>Termination</strong></u></p>
      <p>You agree that Onai, in its sole discretion, may suspend or terminate your account (or any part thereof) or use of the Site and remove and discard any content within the Site, for any reason, including, without limitation, for lack of use or if Onai believes that you have violated or acted inconsistently with the letter or spirit of these Terms of Use. Any suspected fraudulent, abusive or illegal activity that may be grounds for termination of your use of Site, may be referred to appropriate law enforcement authorities. Onai may also in its sole discretion and at any time discontinue providing the Site, or any part thereof, with or without notice. You agree that any termination of your access to the Site under any provision of this Terms of Use may be effected without prior notice, and acknowledge and agree that Onai may (but has obligation to) immediately deactivate or delete your account and all related information and files in your account and/or bar any further access to such files or the Site. Termination of your account or access to any component of the Site will not terminate Onai’s rights to your User Content. Further, you agree that Onai will not be liable to you or any third party for any termination of your access to the Site.</p>
      <p><br /><br />
        <u><strong>General</strong></u></p>
      <p>These Terms of Use constitute the entire agreement between you and Onai and govern your use of the Site, superseding any prior agreements between you and Onai with respect to the Site. These Terms of Use will be governed by the laws of the State of California without regard to its conflict of law provisions. With respect to any disputes or claims not subject to arbitration, as set forth above, you and Onai agree to submit to the personal and exclusive jurisdiction of the state and federal courts located within Santa Clara County, California. The failure of Onai to exercise or enforce any right or provision of these Terms of Use will not constitute a waiver of such right or provision. If any provision of these Terms of Use is found by a court of competent jurisdiction to be invalid, the parties nevertheless agree that the court should endeavor to give effect to the parties’ intentions as reflected in the provision, and the other provisions of these Terms of Use remain in full force and effect. You agree that regardless of any statute or law to the contrary, any claim or cause of action arising out of or related to use of the Site or these Terms of Use must be filed within one (1) year after such claim or cause of action arose or be forever barred. A printed version of this agreement and of any notice given in electronic form will be admissible in judicial or administrative proceedings based upon or relating to this agreement to the same extent and subject to the same conditions as other business documents and records originally generated and maintained in printed form. You may not assign this Terms of Use without the prior written consent of Onai, but Onai may assign or transfer this Terms of Use, in whole or in part, without restriction. The section titles in these Terms of Use are for convenience only and have no legal or contractual effect. Notices to you may be made via either email or regular mail. The Site may also provide notices to you of changes to these Terms of Use or other matters by displaying notices or links to notices generally on the Site.</p>
      <p><br /><br />
        <u><strong>Your Privacy</strong></u></p>
      <p>At Onai, we respect the privacy of our users. For details please see our Privacy Policy.  By using the Site, you consent to our collection and use of personal data as outlined therein.</p>
      <p><br /><br />
        <u><strong>Questions?  Concerns?</strong></u></p>
      <p>Please contact us at info@onai.com to report any violations of these Terms of Use or to pose any questions regarding this Terms of Use or the Site.
        <br /><br /></p>
      <article><h3 id="tm">Trademarks</h3><p>"Onai", "On AI", "Coronai", and the Onai logo are trademarks of Onai Inc., which reserves all rights.  The absence of a product or service name or logo from the preceding list does not constitute a waiver of Onai’s trademark, service mark or other intellectual property rights concerning that name or logo.</p> </article>
    </Typography>
  </div >
}

export default App;
